import {
  ReportType,
  TEvalAccountByDatePaPayoutNewJodyTable,
  TEvalAnalysisData,
  TEvalAnalysisSummaryData,
  TOption,
  TPayoutsAmountReportTable,
  TPayoutsTotalsReportTable,
  getPeriodOptions,
  getCategoryOptions,
  getGroupByOptions,
  getProductTypeOptions,
  TReportActiveUsersByProductData,
  TReportAmountOfRebillsData,
  TReportAverageAmountByProductsBreakdownData,
  TReportAveragePaymentsByUserGroupData,
  TReportAverageLifetimeValueCohortAnalysisData,
  TReportCancelFeedbackData,
  TReportChurnRateData,
  TReportIncomeData,
  TReportDownloadByFilesBreakdownData,
  TReportCreditsSpentByProductsBreakdownData,
  TReportInvoicesBySignupFormData,
  TReportNumberOfPaymentsByBillingPlanData,
  TReportNumberOfRebillsData,
  TReportNewAffiliateCommissionsData,
  TReportOldAffiliateCommissionsByProductData,
  TReportNewAffiliateCommissionsByProductData,
  TReportOldAffiliateSaleNumberData,
  TReportNewAffiliateSaleNumberData,
  TReportConversionRateData,
  TReportRefundsByCustomerCountryData,
  TReportTaxByCustomerCountryData,
  TReportTaxByCustomerStateData,
  TReportRefundsByPaymentSystemBreakdownData,
  TReportPaymentsByProductCategoriesBreakdownData,
  TReportRefundsByProductCategoriesBreakdownData,
  TReportRefundsByProductsBreakdownData,
  TReportPaymentsBySignupFormBreakdownData,
  TReportPaymentsMinusRefundsByCustomerCountryData,
  TReportPaymentsMinusRefundsByCustomerStateData,
  TReportPaymentsVsRefundsData,
  TReportProductConversionData,
  TReportRefundsByUsedCouponData,
  TReportRefundsDistributionByCustomerCountryData,
  TReportRetentionRateData,
  TReportRollingConversionData,
  TReportTaxData,
  TReportPANewRenewalResetByMonthData,
  TReportRefundsRateData,
  TReportUserDistributionByCustomFieldData,
  TReportUserDistributionByCustomFieldByDateData,
  TReportUserLifetimeData,
  TReportUsersByUserGroupsData,
  TReportNewAvalAccountByMonthData,
  TBundlesPAAccountsData,
  TReportNewAffiliateClicksData,
  TReportNewAffiliateByUsersData,
  TPAActivePayoutsAddonsData,
  TReportAffiliatePayoutData,
} from '@src/types';

export const mockUsers: TOption[] = [
  { label: 'user1', value: '1' },
  { label: 'user2', value: '2' },
  { label: 'user3', value: '3' },
  { label: 'user4', value: '4' },
];

export const customFieldOptions: TOption[] = [
  { label: 'Preferred Language', value: 'preferred_language' },
];

export const maxDailyProfitAllowedOption: TOption[] = [
  { label: '30%', value: '30' },
  { label: '40%', value: '40' },
  { label: '50%', value: '50' },
  { label: '60%', value: '60' },
  { label: '70%', value: '70' },
  { label: '80%', value: '80' },
  { label: '90%', value: '90' },
  { label: '100%', value: '100' },
];

export const minTradingDayOptions: TOption[] = [
  { label: '5', value: '5' },
  { label: '7', value: '7' },
  { label: '10', value: '10' },
];

export const accountStatusOption: TOption[] = [
  { label: 'Live Only', value: 'live_only' },
  { label: 'All (warning - will return excess data!)', value: 'all' },
];

export const dailyProfitOptions: TOption[] = [
  { label: '$200', value: '200' },
  { label: '$300', value: '300' },
  { label: '$400', value: '400' },
  { label: '$500', value: '500' },
  { label: '$750', value: '750' },
  { label: '$1000', value: '1000' },
  { label: '$1250', value: '1250' },
  { label: '$1500', value: '1500' },
  { label: '$2000', value: '2000' },
  { label: '$2500', value: '2500' },
  { label: '$3000', value: '3000' },
  { label: '$3500', value: '3500' },
  { label: '$4000', value: '4000' },
  { label: '$4500', value: '4500' },
  { label: '$5000', value: '5000' },
  { label: '$5500', value: '5500' },
  { label: '$6000', value: '6000' },
  { label: '$6500', value: '6500' },
  { label: '$7000', value: '7000' },
  { label: '$7500', value: '7500' },
];

export const paDailyPLAccountStatusOptions: TOption[] = [
  { label: 'All', value: 'all' },
  { label: 'Live Only', value: 'live_only' },
];

export const couponOptions: TOption[] = [
  { label: 'SUMMER2025', value: 'SUMMER2025' },
  { label: 'WINTER2025', value: 'WINTER2025' },
  { label: 'BLACKFRIDAY', value: 'BLACKFRIDAY' },
  { label: 'NEWYEAR2025', value: 'NEWYEAR2025' },
  { label: 'SPRING2025', value: 'SPRING2025' },
];

export const userGroupOptions: TOption[] = [
  {
    label: '15% summer June and July 2025',
    value: '15% summer June and July 2025',
  },
  { label: '20% commision', value: '20% commision' },
  { label: 'Darrell 15%', value: 'Darrell 15%' },
];

export const paymentSystemOptions: TOption[] = [
  { label: 'Stripe', value: 'stripe' },
  { label: 'PayPal', value: 'paypal' },
  { label: 'PayPal Express', value: 'paypal-express' },
  { label: 'Stripe Apple Pay', value: 'stripe-apple-pay' },
  { label: 'Network Merchants Inc', value: 'nmi-com' },
];

export const productCategoryOptions: TOption[] = [
  {
    label: 'Active Leeloo Traders Only (Sale)',
    value: 'Active Leeloo Traders Only (Sale)',
  },
  { label: 'Products with Commission', value: 'Products with Commission' },
  { label: 'Turbos', value: 'Turbos' },
  { label: 'All Monthly Evaluations', value: 'All Monthly Evaluations' },
  { label: 'Add-ons', value: 'Add-ons' },
  { label: 'Full Membership', value: 'Full Membership' },
];

// Generate options dynamically from enums
export const periodOptions: TOption[] = getPeriodOptions();

export const groupByOptions: TOption[] = getGroupByOptions();

export const categoryOptions: TOption[] = getCategoryOptions();

export const productTypeOptions: TOption[] = getProductTypeOptions();

export const mockNewAvalAccountByMonth: TReportNewAvalAccountByMonthData[] = [
  {
    package: '8 Contract | $50,000 Launch | Investor',
    new_accounts: 2450,
    renewals: 780,
  },
  {
    package: 'Leeloo Entry Level (LE) Burst | 25ct, 250k | Trailing Drawdown',
    new_accounts: 1650,
    renewals: 0,
  },
  {
    package: '12 Contract | $100,000 Climb | Investor',
    new_accounts: 320,
    renewals: 450,
  },
  {
    package: '15 Contract | $150,000 Cruise | Investor',
    new_accounts: 280,
    renewals: 420,
  },
  {
    package: 'LB Bundle | 30 micros',
    new_accounts: 180,
    renewals: 120,
  },
  {
    package: 'LB Bundle | 12 Contract',
    new_accounts: 680,
    renewals: 720,
  },
  {
    package: 'LB Bundle | 25 Contract',
    new_accounts: 0,
    renewals: 1480,
  },
  {
    package: 'Leeloo Entry Level (LE) Cruise | 15ct, 150k',
    new_accounts: 120,
    renewals: 0,
  },
];

export const mockActiveUsersByProducts: TReportActiveUsersByProductData[] = [
  {
    product:
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds',
    active_users: 1200,
  },
  {
    product: '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown',
    active_users: 950,
  },
  {
    product: '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown',
    active_users: 780,
  },
  {
    product: '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown',
    active_users: 430,
  },
  {
    product: '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown',
    active_users: 670,
  },
];

export const mockPANewRenewalResetByMonth: TReportPANewRenewalResetByMonthData[] =
  [
    {
      package: 'TEST/DXFINTER Aspire | 3 Contract | $25,000',
      new_accounts: 152,
      renewals: 8,
      resets: 0,
    },
    {
      package: 'Test Stocks  | 3 Contract | $25,000',
      new_accounts: 148,
      renewals: 0,
      resets: 0,
    },
    {
      package: 'Leeloo Launch | 30 day | Leeloo 8 ct $750',
      new_accounts: 985,
      renewals: 12,
      resets: 1,
    },
    {
      package: 'Kickstart | $75,000',
      new_accounts: 24,
      renewals: 0,
      resets: 0,
    },
    {
      package: '3 Contract | $100,000',
      new_accounts: 152,
      renewals: 0,
      resets: 0,
    },
    {
      package: 'Glide 8 Accelerator',
      new_accounts: 12,
      renewals: 0,
      resets: 0,
    },
    {
      package: '8 Contract | $50,000 Launch | Investor',
      new_accounts: 12,
      renewals: 0,
      resets: 0,
    },
    {
      package: '15 Contract | $100,000 Climb | Investor',
      new_accounts: 138,
      renewals: 38,
      resets: 0,
    },
    {
      package: '25 Contract | $250,000 Climb | Investor',
      new_accounts: 42,
      renewals: 0,
      resets: 0,
    },
    {
      package: '30 Contract | $150,000 Cruise | Investor',
      new_accounts: 148,
      renewals: 6,
      resets: 0,
    },
    {
      package: 'LB Bundle | 30 micros',
      new_accounts: 35,
      renewals: 0,
      resets: 0,
    },
    {
      package: 'LB Bundle | $25,000 | 3 mini | micros',
      new_accounts: 62,
      renewals: 0,
      resets: 0,
    },
    {
      package: 'LB Bundle | 12 Contract | 3 micros',
      new_accounts: 28,
      renewals: 0,
      resets: 0,
    },
    {
      package: 'LB Burst 1 | $25 micro | Trailing Drawdown',
      new_accounts: 35,
      renewals: 0,
      resets: 0,
    },
    {
      package: 'LB Bundle | 25 micro',
      new_accounts: 0,
      renewals: 0,
      resets: 0,
    },
    {
      package: 'Leeloo Entry Level (LE) Accelerator | 12 days Trailing DD',
      new_accounts: 48,
      renewals: 12,
      resets: 0,
    },
    {
      package: 'Leeloo Ignite | 1 contract | $100,000',
      new_accounts: 18,
      renewals: 0,
      resets: 0,
    },
    {
      package: 'Leeloo Entry Level (LE) Leap | Investor',
      new_accounts: 32,
      renewals: 0,
      resets: 0,
    },
    {
      package: 'Leeloo Entry Level (LE) Launch | 8ct, 50k',
      new_accounts: 42,
      renewals: 0,
      resets: 0,
    },
  ];

export const mockAmountOfRebills: TReportAmountOfRebillsData[] = [
  { date: '11/17/25', amount_of_rebills: 12500 },
  { date: '11/18/25', amount_of_rebills: 13000 },
  { date: '11/19/25', amount_of_rebills: 12850 },
  { date: '11/20/25', amount_of_rebills: 10500 },
  { date: '11/21/25', amount_of_rebills: 8000 },
  { date: '11/22/25', amount_of_rebills: 7500 },
];

export const mockNumberOfRebills: TReportNumberOfRebillsData[] = [
  { date: '11/17/25', rebills: 125 },
  { date: '11/18/25', rebills: 130 },
  { date: '11/19/25', rebills: 128 },
  { date: '11/20/25', rebills: 105 },
  { date: '11/21/25', rebills: 80 },
  { date: '11/22/25', rebills: 75 },
];

export const mockOldAffiliateSaleNumber: TReportOldAffiliateSaleNumberData[] = [
  { date: 'Jan 2025', sales: 45 },
  { date: 'Feb 2025', sales: 52 },
  { date: 'Mar 2025', sales: 48 },
  { date: 'Apr 2025', sales: 61 },
  { date: 'May 2025', sales: 58 },
  { date: 'Jun 2025', sales: 67 },
  { date: 'Jul 2025', sales: 72 },
  { date: 'Aug 2025', sales: 69 },
  { date: 'Sep 2025', sales: 74 },
  { date: 'Oct 2025', sales: 81 },
  { date: 'Nov 2025', sales: 78 },
  { date: 'Dec 2025', sales: 85 },
];

export const mockNewAffiliateSaleNumber: TReportNewAffiliateSaleNumberData[] = [
  { date: 'Jan 2025', commissions: 28 },
  { date: 'Feb 2025', commissions: 34 },
  { date: 'Mar 2025', commissions: 31 },
  { date: 'Apr 2025', commissions: 42 },
  { date: 'May 2025', commissions: 39 },
  { date: 'Jun 2025', commissions: 47 },
  { date: 'Jul 2025', commissions: 53 },
  { date: 'Aug 2025', commissions: 49 },
  { date: 'Sep 2025', commissions: 56 },
  { date: 'Oct 2025', commissions: 62 },
  { date: 'Nov 2025', commissions: 58 },
  { date: 'Dec 2025', commissions: 64 },
];

export const mockOldAffiliatePayoutByUsers: TReportAffiliatePayoutData[] = [
  { userName: 'iaffe-funded-trader', payout: 128.61 },
  { userName: 'babouh77', payout: 1181.99 },
  { userName: 'gabeparrraz1', payout: 258.9 },
  { userName: 'jawedz', payout: 106.21 },
  { userName: 'NDKing', payout: 2525.5 },
  { userName: 'rebecca4225', payout: 401.65 },
  { userName: 'tradingfunder', payout: 80.98 },
  { userName: 'raceman02', payout: 99.05 },
  { userName: 'lastaria', payout: 82.65 },
  { userName: 'onlineprop', payout: 83.59 },
  { userName: 'protrader-mike', payout: 604.79 },
  { userName: 'rufanpressevenezuela', payout: 309.49 },
  { userName: 'tenoreno1', payout: 196.46 },
  { userName: 'ustari', payout: 128.62 },
  { userName: 'shgitladeal', payout: 84.69 },
  { userName: 'playtradewin', payout: 403.18 },
  { userName: 'livingfromtrading', payout: 91.15 },
  { userName: 'pschliebs', payout: 329.42 },
  { userName: 'palc1721', payout: 202.58 },
  { userName: 'funding4traders', payout: 408.92 },
];

export const mockNewAffiliatePayoutByUsers: TReportAffiliatePayoutData[] = [
  { userName: 'crypto-master', payout: 2250.75 },
  { userName: 'tradepro88', payout: 1890.25 },
  { userName: 'forexking123', payout: 1650.0 },
  { userName: 'daytrader_supreme', payout: 1420.5 },
  { userName: 'propfirm_ninja', payout: 980.3 },
  { userName: 'swing_trader_joe', payout: 875.9 },
  { userName: 'scalper_pro', payout: 720.45 },
  { userName: 'futures_expert', payout: 650.8 },
  { userName: 'options_wizard', payout: 580.25 },
  { userName: 'algo_trader_99', payout: 495.6 },
  { userName: 'market_maker_1', payout: 450.75 },
  { userName: 'trend_follower', payout: 380.9 },
  { userName: 'volatility_trader', payout: 320.5 },
  { userName: 'breakout_hunter', payout: 275.35 },
  { userName: 'support_resistance', payout: 240.8 },
];

export const mockNewAffiliateCommissions: TReportNewAffiliateCommissionsData[] =
  [
    { date: '01/01/26', commissions: 2300 },
    { date: '01/08/26', commissions: 2800 },
    { date: '01/15/26', commissions: 3100 },
    { date: '01/22/26', commissions: 2900 },
    { date: '01/29/26', commissions: 3400 },
    { date: '02/05/26', commissions: 3900 },
  ];

export const mockOldAffiliateCommissionsByProduct: TReportOldAffiliateCommissionsByProductData[] =
  [
    {
      date: 'Jan 2026',
      products: {
        '8 Contract | $50,000 Launch | Investor': 1850,
        '12 Contract | $100,000 Climb | Investor': 2200,
        '15 Contract | $150,000 Cruise | Investor': 1650,
        'LB Bundle | 30 micros': 950,
        'Leeloo Express | 14 Days | 12 Contract': 1450,
      },
      products_previous: {
        '8 Contract | $50,000 Launch | Investor': 1650,
        '12 Contract | $100,000 Climb | Investor': 2000,
        '15 Contract | $150,000 Cruise | Investor': 1500,
        'LB Bundle | 30 micros': 850,
        'Leeloo Express | 14 Days | 12 Contract': 1300,
      },
      products_previous_year: {
        '8 Contract | $50,000 Launch | Investor': 1400,
        '12 Contract | $100,000 Climb | Investor': 1800,
        '15 Contract | $150,000 Cruise | Investor': 1350,
        'LB Bundle | 30 micros': 750,
        'Leeloo Express | 14 Days | 12 Contract': 1100,
      },
    },
    {
      date: 'Feb 2026',
      products: {
        '8 Contract | $50,000 Launch | Investor': 2100,
        '12 Contract | $100,000 Climb | Investor': 2450,
        '15 Contract | $150,000 Cruise | Investor': 1850,
        'LB Bundle | 30 micros': 1100,
        'Leeloo Express | 14 Days | 12 Contract': 1650,
      },
      products_previous: {
        '8 Contract | $50,000 Launch | Investor': 1850,
        '12 Contract | $100,000 Climb | Investor': 2200,
        '15 Contract | $150,000 Cruise | Investor': 1650,
        'LB Bundle | 30 micros': 950,
        'Leeloo Express | 14 Days | 12 Contract': 1450,
      },
      products_previous_year: {
        '8 Contract | $50,000 Launch | Investor': 1600,
        '12 Contract | $100,000 Climb | Investor': 2050,
        '15 Contract | $150,000 Cruise | Investor': 1550,
        'LB Bundle | 30 micros': 850,
        'Leeloo Express | 14 Days | 12 Contract': 1250,
      },
    },
    {
      date: 'Mar 2026',
      products: {
        '8 Contract | $50,000 Launch | Investor': 2350,
        '12 Contract | $100,000 Climb | Investor': 2700,
        '15 Contract | $150,000 Cruise | Investor': 2050,
        'LB Bundle | 30 micros': 1250,
        'Leeloo Express | 14 Days | 12 Contract': 1850,
      },
      products_previous: {
        '8 Contract | $50,000 Launch | Investor': 2100,
        '12 Contract | $100,000 Climb | Investor': 2450,
        '15 Contract | $150,000 Cruise | Investor': 1850,
        'LB Bundle | 30 micros': 1100,
        'Leeloo Express | 14 Days | 12 Contract': 1650,
      },
      products_previous_year: {
        '8 Contract | $50,000 Launch | Investor': 1850,
        '12 Contract | $100,000 Climb | Investor': 2300,
        '15 Contract | $150,000 Cruise | Investor': 1750,
        'LB Bundle | 30 micros': 950,
        'Leeloo Express | 14 Days | 12 Contract': 1450,
      },
    },
    {
      date: 'Apr 2026',
      products: {
        '8 Contract | $50,000 Launch | Investor': 2200,
        '12 Contract | $100,000 Climb | Investor': 2550,
        '15 Contract | $150,000 Cruise | Investor': 1950,
        'LB Bundle | 30 micros': 1150,
        'Leeloo Express | 14 Days | 12 Contract': 1750,
      },
      products_previous: {
        '8 Contract | $50,000 Launch | Investor': 2350,
        '12 Contract | $100,000 Climb | Investor': 2700,
        '15 Contract | $150,000 Cruise | Investor': 2050,
        'LB Bundle | 30 micros': 1250,
        'Leeloo Express | 14 Days | 12 Contract': 1850,
      },
      products_previous_year: {
        '8 Contract | $50,000 Launch | Investor': 1950,
        '12 Contract | $100,000 Climb | Investor': 2200,
        '15 Contract | $150,000 Cruise | Investor': 1650,
        'LB Bundle | 30 micros': 1000,
        'Leeloo Express | 14 Days | 12 Contract': 1550,
      },
    },
  ];

export const mockNewAffiliateCommissionsByProduct: TReportNewAffiliateCommissionsByProductData[] =
  [
    {
      date: 'Jan 2026',
      products: {
        '8 Contract | $50,000 Launch | Investor': 980,
        '12 Contract | $100,000 Climb | Investor': 1150,
        '15 Contract | $150,000 Cruise | Investor': 850,
        'LB Bundle | 30 micros': 520,
        'Leeloo Express | 14 Days | 12 Contract': 750,
      },
      products_previous: {
        '8 Contract | $50,000 Launch | Investor': 850,
        '12 Contract | $100,000 Climb | Investor': 1000,
        '15 Contract | $150,000 Cruise | Investor': 750,
        'LB Bundle | 30 micros': 450,
        'Leeloo Express | 14 Days | 12 Contract': 650,
      },
      products_previous_year: {
        '8 Contract | $50,000 Launch | Investor': 720,
        '12 Contract | $100,000 Climb | Investor': 880,
        '15 Contract | $150,000 Cruise | Investor': 650,
        'LB Bundle | 30 micros': 380,
        'Leeloo Express | 14 Days | 12 Contract': 550,
      },
    },
    {
      date: 'Feb 2026',
      products: {
        '8 Contract | $50,000 Launch | Investor': 1150,
        '12 Contract | $100,000 Climb | Investor': 1350,
        '15 Contract | $150,000 Cruise | Investor': 1050,
        'LB Bundle | 30 micros': 620,
        'Leeloo Express | 14 Days | 12 Contract': 880,
      },
      products_previous: {
        '8 Contract | $50,000 Launch | Investor': 980,
        '12 Contract | $100,000 Climb | Investor': 1150,
        '15 Contract | $150,000 Cruise | Investor': 850,
        'LB Bundle | 30 micros': 520,
        'Leeloo Express | 14 Days | 12 Contract': 750,
      },
      products_previous_year: {
        '8 Contract | $50,000 Launch | Investor': 850,
        '12 Contract | $100,000 Climb | Investor': 1020,
        '15 Contract | $150,000 Cruise | Investor': 780,
        'LB Bundle | 30 micros': 450,
        'Leeloo Express | 14 Days | 12 Contract': 650,
      },
    },
    {
      date: 'Mar 2026',
      products: {
        '8 Contract | $50,000 Launch | Investor': 1320,
        '12 Contract | $100,000 Climb | Investor': 1550,
        '15 Contract | $150,000 Cruise | Investor': 1220,
        'LB Bundle | 30 micros': 720,
        'Leeloo Express | 14 Days | 12 Contract': 1020,
      },
      products_previous: {
        '8 Contract | $50,000 Launch | Investor': 1150,
        '12 Contract | $100,000 Climb | Investor': 1350,
        '15 Contract | $150,000 Cruise | Investor': 1050,
        'LB Bundle | 30 micros': 620,
        'Leeloo Express | 14 Days | 12 Contract': 880,
      },
      products_previous_year: {
        '8 Contract | $50,000 Launch | Investor': 980,
        '12 Contract | $100,000 Climb | Investor': 1180,
        '15 Contract | $150,000 Cruise | Investor': 920,
        'LB Bundle | 30 micros': 520,
        'Leeloo Express | 14 Days | 12 Contract': 750,
      },
    },
    {
      date: 'Apr 2026',
      products: {
        '8 Contract | $50,000 Launch | Investor': 1250,
        '12 Contract | $100,000 Climb | Investor': 1480,
        '15 Contract | $150,000 Cruise | Investor': 1150,
        'LB Bundle | 30 micros': 680,
        'Leeloo Express | 14 Days | 12 Contract': 950,
      },
      products_previous: {
        '8 Contract | $50,000 Launch | Investor': 1320,
        '12 Contract | $100,000 Climb | Investor': 1550,
        '15 Contract | $150,000 Cruise | Investor': 1220,
        'LB Bundle | 30 micros': 720,
        'Leeloo Express | 14 Days | 12 Contract': 1020,
      },
      products_previous_year: {
        '8 Contract | $50,000 Launch | Investor': 1080,
        '12 Contract | $100,000 Climb | Investor': 1280,
        '15 Contract | $150,000 Cruise | Investor': 1000,
        'LB Bundle | 30 micros': 580,
        'Leeloo Express | 14 Days | 12 Contract': 850,
      },
    },
  ];

export const mockRefundsDistributionByCustomerCountry: TReportRefundsDistributionByCustomerCountryData[] =
  [
    { country: 'United States', amount: 5000 },
    { country: 'Canada', amount: 2000 },
    { country: 'United Kingdom', amount: 1500 },
    { country: 'Germany', amount: 1000 },
    { country: 'Australia', amount: 800 },
  ];

export const mockUserDistributionByCustomField: TReportUserDistributionByCustomFieldData[] =
  [
    { field_value: 'English', user_count: 18152 },
    { field_value: 'Spanish', user_count: 5756 },
    { field_value: 'French', user_count: 5761 },
    { field_value: 'German', user_count: 2340 },
    { field_value: 'Portuguese', user_count: 1890 },
    { field_value: 'Italian', user_count: 1450 },
    { field_value: 'Japanese', user_count: 980 },
    { field_value: 'Korean', user_count: 780 },
  ];

export const mockNewAffiliateClicks: TReportNewAffiliateClicksData[] = [
  {
    period: 'Jan 2025',
    all_clicks: 2450,
    unique_clicks: 1780,
    all_clicks_previous: 1980,
    unique_clicks_previous: 1450,
    all_clicks_previous_year: 1750,
    unique_clicks_previous_year: 1280,
  },
  {
    period: 'Feb 2025',
    all_clicks: 2680,
    unique_clicks: 1920,
    all_clicks_previous: 2200,
    unique_clicks_previous: 1580,
    all_clicks_previous_year: 1920,
    unique_clicks_previous_year: 1380,
  },
  {
    period: 'Mar 2025',
    all_clicks: 2920,
    unique_clicks: 2080,
    all_clicks_previous: 2450,
    unique_clicks_previous: 1780,
    all_clicks_previous_year: 2150,
    unique_clicks_previous_year: 1550,
  },
  {
    period: 'Apr 2025',
    all_clicks: 2820,
    unique_clicks: 1980,
    all_clicks_previous: 2680,
    unique_clicks_previous: 1920,
    all_clicks_previous_year: 2350,
    unique_clicks_previous_year: 1680,
  },
  {
    period: 'May 2025',
    all_clicks: 3180,
    unique_clicks: 2250,
    all_clicks_previous: 2820,
    unique_clicks_previous: 1980,
    all_clicks_previous_year: 2580,
    unique_clicks_previous_year: 1850,
  },
  {
    period: 'Jun 2025',
    all_clicks: 3450,
    unique_clicks: 2420,
    all_clicks_previous: 3180,
    unique_clicks_previous: 2250,
    all_clicks_previous_year: 2920,
    unique_clicks_previous_year: 2080,
  },
];

export const mockNewAffiliateByUsers: TReportNewAffiliateByUsersData[] = [
  {
    user_name: 'David Anderson',
    commissions: 28400.5,
  },
  {
    user_name: 'Jennifer Taylor',
    commissions: 32650.75,
  },
  {
    user_name: 'Christopher Lee',
    commissions: 35900.25,
  },
  {
    user_name: 'Amanda White',
    commissions: 33200.0,
  },
  {
    user_name: 'Matthew Brown',
    commissions: 41500.6,
  },
  {
    user_name: 'Lisa Thompson',
    commissions: 48750.9,
  },
];

export const mockUserDistributionByCustomFieldByDate: TReportUserDistributionByCustomFieldByDateData[] =
  [
    {
      date: '12/13/25-12/07/25',
      field_values: { English: 11, Spanish: 0, French: 2 },
      field_values_previous: { English: 8, Spanish: 2, French: 1 },
      field_values_previous_year: { English: 9, Spanish: 1, French: 2 },
    },
    {
      date: '12/08/25-12/14/25',
      field_values: { English: 0, Spanish: 0, French: 0 },
      field_values_previous: { English: 0, Spanish: 0, French: 0 },
      field_values_previous_year: { English: 0, Spanish: 0, French: 0 },
    },
    {
      date: '12/16/25-12/21/25',
      field_values: { English: 0, Spanish: 0, French: 0 },
      field_values_previous: { English: 0, Spanish: 0, French: 0 },
      field_values_previous_year: { English: 0, Spanish: 0, French: 0 },
    },
    {
      date: '12/22/25-12/28/25',
      field_values: { English: 0, Spanish: 0, French: 0 },
      field_values_previous: { English: 0, Spanish: 0, French: 0 },
      field_values_previous_year: { English: 0, Spanish: 0, French: 0 },
    },
    {
      date: '12/29/25-01/04/25',
      field_values: { English: 0, Spanish: 0, French: 0 },
      field_values_previous: { English: 0, Spanish: 0, French: 0 },
      field_values_previous_year: { English: 0, Spanish: 0, French: 0 },
    },
  ];
export const mockEvalAnalysisData: TEvalAnalysisData[] = [
  {
    package: 'Kickstart | $75,000',
    total_accounts: 24,
    avg_days: 19,
    resets: 2,
    resets_percentage: 8.33,
    days_5: { count: 22, percentage: 91.67 },
    days_10: { count: 22, percentage: 91.67 },
    days_14: { count: 22, percentage: 91.67 },
    days_30: { count: 22, percentage: 91.67 },
    days_60: { count: 7, percentage: 29.17 },
    days_90: { count: 3, percentage: 12.5 },
    days_120: { count: 2, percentage: 8.33 },
    days_150: { count: 0, percentage: 0.0 },
    days_180: { count: 0, percentage: 0.0 },
    days_210: { count: 0, percentage: 0.0 },
    days_240: { count: 0, percentage: 0.0 },
    days_270: { count: 0, percentage: 0.0 },
    days_300: { count: 0, percentage: 0.0 },
    days_330: { count: 0, percentage: 0.0 },
    days_360: { count: 0, percentage: 0.0 },
  },
  {
    package: 'Leeloo Ignite 10 days | 1 contract | $108,000',
    total_accounts: 1159,
    avg_days: 4,
    resets: 0,
    resets_percentage: 0.0,
    days_5: { count: 1037, percentage: 89.47 },
    days_10: { count: 983, percentage: 84.81 },
    days_14: { count: 971, percentage: 83.78 },
    days_30: { count: 0, percentage: 0.0 },
    days_60: { count: 0, percentage: 0.0 },
    days_90: { count: 0, percentage: 0.0 },
    days_120: { count: 0, percentage: 0.0 },
    days_150: { count: 0, percentage: 0.0 },
    days_180: { count: 0, percentage: 0.0 },
    days_210: { count: 0, percentage: 0.0 },
    days_240: { count: 0, percentage: 0.0 },
    days_270: { count: 0, percentage: 0.0 },
    days_300: { count: 0, percentage: 0.0 },
    days_330: { count: 0, percentage: 0.0 },
    days_360: { count: 0, percentage: 0.0 },
  },
  {
    package: '3 Contract | $25,000 Aspire | Investor',
    total_accounts: 2762,
    avg_days: 8,
    resets: 4,
    resets_percentage: 0.14,
    days_5: { count: 1656, percentage: 60.03 },
    days_10: { count: 1401, percentage: 50.72 },
    days_14: { count: 1301, percentage: 47.1 },
    days_30: { count: 863, percentage: 31.25 },
    days_60: { count: 0, percentage: 0.0 },
    days_90: { count: 0, percentage: 0.0 },
    days_120: { count: 0, percentage: 0.0 },
    days_150: { count: 0, percentage: 0.0 },
    days_180: { count: 0, percentage: 0.0 },
    days_210: { count: 0, percentage: 0.0 },
    days_240: { count: 0, percentage: 0.0 },
    days_270: { count: 0, percentage: 0.0 },
    days_300: { count: 0, percentage: 0.0 },
    days_330: { count: 0, percentage: 0.0 },
    days_360: { count: 0, percentage: 0.0 },
  },
  {
    package: '8 Contract | $50,000 Launch | Investor',
    total_accounts: 6519,
    avg_days: 6,
    resets: 6,
    resets_percentage: 0.09,
    days_5: { count: 3324, percentage: 50.99 },
    days_10: { count: 2908, percentage: 44.61 },
    days_14: { count: 2717, percentage: 41.68 },
    days_30: { count: 2133, percentage: 32.72 },
    days_60: { count: 3, percentage: 0.05 },
    days_90: { count: 2, percentage: 0.03 },
    days_120: { count: 2, percentage: 0.03 },
    days_150: { count: 2, percentage: 0.03 },
    days_180: { count: 2, percentage: 0.03 },
    days_210: { count: 1, percentage: 0.02 },
    days_240: { count: 0, percentage: 0.0 },
    days_270: { count: 0, percentage: 0.0 },
    days_300: { count: 0, percentage: 0.0 },
    days_330: { count: 0, percentage: 0.0 },
    days_360: { count: 0, percentage: 0.0 },
  },
  {
    package: '12 Contract | $100,000 Climb | Investor',
    total_accounts: 2985,
    avg_days: 7,
    resets: 8,
    resets_percentage: 0.27,
    days_5: { count: 2098, percentage: 70.28 },
    days_10: { count: 1948, percentage: 65.26 },
    days_14: { count: 1745, percentage: 58.46 },
    days_30: { count: 1447, percentage: 48.48 },
    days_60: { count: 6, percentage: 0.2 },
    days_90: { count: 6, percentage: 0.2 },
    days_120: { count: 3, percentage: 0.1 },
    days_150: { count: 3, percentage: 0.1 },
    days_180: { count: 0, percentage: 0.0 },
    days_210: { count: 0, percentage: 0.0 },
    days_240: { count: 0, percentage: 0.0 },
    days_270: { count: 0, percentage: 0.0 },
    days_300: { count: 0, percentage: 0.0 },
    days_330: { count: 0, percentage: 0.0 },
    days_360: { count: 0, percentage: 0.0 },
  },
];

export const mockEvalAnalysisSummary: TEvalAnalysisSummaryData[] = [
  {
    status: 'AUTO-LIQUIDATED',
    amount: 11146,
    percentage: 55.9,
    avg_days: 3,
    max_days: 87,
  },
  {
    status: '> HOW MANY RESET',
    amount: 124,
    percentage: 0.6,
    avg_days: null,
    max_days: null,
  },
  {
    status: 'RESETS',
    amount: 143,
    percentage: 0.7,
    avg_days: null,
    max_days: null,
  },
  {
    status: 'EXPIRED / NOT RENEWED',
    amount: 8638,
    percentage: 43.3,
    avg_days: null,
    max_days: null,
  },
  {
    status: 'MANUALLY CLOSED IN MINT',
    amount: 3399,
    percentage: 17.0,
    avg_days: null,
    max_days: null,
  },
  {
    status: 'ACTIVE',
    amount: 46,
    percentage: 0.2,
    avg_days: 50,
    max_days: 97,
  },
  {
    status: 'TOTAL',
    amount: 19952,
    percentage: 100,
    avg_days: null,
    max_days: null,
  },
];

export const accountStatusOptionsSimple: TOption[] = [
  { label: 'Show All', value: 'show_all' },
  { label: 'Active Only', value: 'active_only' },
];

export const payoutStatusOptions: TOption[] = [
  { label: 'Show All', value: 'show_all' },
  { label: 'With Payout Only', value: 'with_payout_only' },
];

export const mockPAActivePayoutsAddons: TPAActivePayoutsAddonsData[] = [
  {
    name: 'Dominikus Joedicke',
    account_id: 'PA-LL004702-240',
    account_package:
      'Leeloo Entry Level LE 15 Contract | $150,000 Cruise | Investor LE',
    eval_purchase: '16 Nov 2023',
    valid: '5 / 17 Nov 2023 - 17 Nov 2023',
    trading_days: 1,
    balance: '$144,527',
    net_pl: '$-5,473',
    acc_payouts: '-',
    total_paid_by_customer: '-',
    acc_payout_amount: '-',
    addon_reduced_days_to_qualify: true,
    addon_extra_days_200: true,
    addon_30_day_payouts: false,
    addon_15_day_payouts: false,
    addon_lifetime_days_179: true,
    addon_lifetime_days_365: false,
  },
  {
    name: 'Francisco Santos Rodriguez',
    account_id: 'PA_LL004815-075',
    account_package:
      'Leeloo Entry Level LE 15 Contract | $150,000 Cruise | Investor LF',
    eval_purchase: '06 Feb 2025',
    valid: '5 / 06 Mar 2025 - 09 Mar 2025',
    trading_days: 4,
    balance: '$146,870',
    net_pl: '$-3,130',
    acc_payouts: '-',
    total_paid_by_customer: '-',
    acc_payout_amount: '-',
    addon_reduced_days_to_qualify: false,
    addon_extra_days_200: false,
    addon_30_day_payouts: false,
    addon_15_day_payouts: false,
    addon_lifetime_days_179: false,
    addon_lifetime_days_365: false,
  },
  {
    name: 'Dario Giovanni Castellazzi',
    account_id: 'PA-LL005248-175',
    account_package:
      'Leeloo Entry Level LE 15 Contract | $150,000 Cruise | Investor LE',
    eval_purchase: '27 Jun 2023',
    valid: '5 / 14 Jul 2023 - 17 Jul 2023',
    trading_days: 2,
    balance: '$146,839',
    net_pl: '$-3,161',
    acc_payouts: '-',
    total_paid_by_customer: '-',
    acc_payout_amount: '-',
    addon_reduced_days_to_qualify: false,
    addon_extra_days_200: false,
    addon_30_day_payouts: false,
    addon_15_day_payouts: false,
    addon_lifetime_days_179: false,
    addon_lifetime_days_365: false,
  },
  {
    name: 'Dario Giovanni Castellazzi',
    account_id: 'PA-LL005248-176',
    account_package:
      'Leeloo Entry Level LE 15 Contract | $150,000 Cruise | Investor LF',
    eval_purchase: '27 Jun 2025',
    valid: '5 / 19 Jul 2025 - 19 Jul 2025',
    trading_days: 1,
    balance: '$147,656',
    net_pl: '$-2,344',
    acc_payouts: '-',
    total_paid_by_customer: '-',
    acc_payout_amount: '-',
    addon_reduced_days_to_qualify: false,
    addon_extra_days_200: false,
    addon_30_day_payouts: false,
    addon_15_day_payouts: false,
    addon_lifetime_days_179: false,
    addon_lifetime_days_365: false,
  },
  {
    name: 'anthony fisher',
    account_id: 'PA-LL005948-016',
    account_package:
      'Leeloo Entry Level LE 15 Contract | $150,000 Cruise | Investor LE',
    eval_purchase: '27 Jun 2023',
    valid: '5 / 20 Jul 2023 - 27 Jul 2023',
    trading_days: 6,
    balance: '$146,898',
    net_pl: '$-3,102',
    acc_payouts: '-',
    total_paid_by_customer: '-',
    acc_payout_amount: '-',
    addon_reduced_days_to_qualify: true,
    addon_extra_days_200: true,
    addon_30_day_payouts: false,
    addon_15_day_payouts: false,
    addon_lifetime_days_179: false,
    addon_lifetime_days_365: true,
  },
  {
    name: 'David Rasmussen',
    account_id: 'PA-LL006150-480',
    account_package:
      'Leeloo Entry Level LE 15 Contract | $150,000 Cruise | Investor LF',
    eval_purchase: '19 Jun 2024',
    valid: '5 / 22 Jul 2024 - 03 Aug 2024',
    trading_days: 10,
    balance: '$145,126',
    net_pl: '$-4,874',
    acc_payouts: '-',
    total_paid_by_customer: '-',
    acc_payout_amount: '-',
    addon_reduced_days_to_qualify: false,
    addon_extra_days_200: false,
    addon_30_day_payouts: false,
    addon_15_day_payouts: false,
    addon_lifetime_days_179: false,
    addon_lifetime_days_365: false,
  },
  {
    name: 'Sachin Kumbhar',
    account_id: 'PA-LL006183-050',
    account_package:
      'Leeloo Entry Level LE 15 Contract | $150,000 Cruise | Investor LE',
    eval_purchase: '25 Jun 2024',
    valid: '5 / 08 Jul 2024 - 18 Jul 2024',
    trading_days: 8,
    balance: '$149,595',
    net_pl: '$-405',
    acc_payouts: '-',
    total_paid_by_customer: '-',
    acc_payout_amount: '-',
    addon_reduced_days_to_qualify: true,
    addon_extra_days_200: true,
    addon_30_day_payouts: false,
    addon_15_day_payouts: false,
    addon_lifetime_days_179: false,
    addon_lifetime_days_365: true,
  },
];

export const mockPAActivePayoutsAddonsChartData = [
  {
    date: '17 Nov 23',
    contracts: 228,
    winningTrades: 86,
    losingTrades: -28,
    accountBalance: 144527.23,
    netPL: -5472.77,
  },
];

export const mockPAActivePayoutsAddonsTradeVolumeData = [
  {
    date: '2024-01-25',
    contracts: 18,
    winningTrades: 12,
    losingTrades: 6,
  },
  {
    date: '2024-01-26',
    contracts: 8,
    winningTrades: 4,
    losingTrades: 5,
  },
  {
    date: '2024-01-27',
    contracts: 86,
    winningTrades: 36,
    losingTrades: 32,
  },
  {
    date: '2024-01-28',
    contracts: 98,
    winningTrades: 24,
    losingTrades: 60,
  },
];

export const mockPAActivePayoutsAddonsBalanceData = [
  {
    date: '2024-01-25',
    accountBalance: 150234.56,
    netPL: 234.56,
  },
  {
    date: '2024-01-26',
    accountBalance: 149876.34,
    netPL: -358.22,
  },
  {
    date: '2024-01-27',
    accountBalance: 151456.78,
    netPL: 1580.44,
  },
  {
    date: '2024-01-28',
    accountBalance: 146870.0,
    netPL: -4586.78,
  },
];

export const mockBundlesPAAccounts: TBundlesPAAccountsData[] = [
  {
    package: 'LB Bundle $50,000 Launch | 8 minis | 30 micros',
    jan: { evals: 1891, fill: 213, payouts: 1, paid: 18080 },
    feb: { evals: 19245, fill: 2779, payouts: 58, paid: 187348 },
    mar: { evals: 2069, fill: 301, payouts: 1, paid: 11200 },
    apr: { evals: 1, fill: 0, payouts: 0, paid: 0 },
    may: { evals: 0, fill: 0, payouts: 0, paid: 0 },
    jun: { evals: 173, fill: 25, payouts: 1, paid: 12300 },
    jul: { evals: 9437, fill: 929, payouts: 22, paid: 24640 },
    aug: { evals: 6133, fill: 823, payouts: 13, paid: 0 },
    sep: { evals: 9607, fill: 1304, payouts: 6, paid: 2507 },
    oct: { evals: 2507, fill: 333, payouts: 13, paid: 7390 },
    nov: { evals: 7390, fill: 1043, payouts: 14, paid: 3808 },
    dec: { evals: 3808, fill: 270, payouts: 1, paid: 21968 },
  },
  {
    package: 'LB Bundle $100,000 Climb | 12 minis | 120 micros',
    jan: { evals: 121, fill: 0, payouts: 0, paid: 0 },
    feb: { evals: 665, fill: 42, payouts: 0, paid: 10470 },
    mar: { evals: 9949, fill: 118, payouts: 5, paid: 18880 },
    apr: { evals: 5296, fill: 279, payouts: 7, paid: 2130 },
    may: { evals: 4709, fill: 282, payouts: 4, paid: 0 },
    jun: { evals: 3, fill: 0, payouts: 0, paid: 0 },
    jul: { evals: 1335, fill: 162, payouts: 3, paid: 2600 },
    aug: { evals: 2266, fill: 163, payouts: 4, paid: 0 },
    sep: { evals: 1772, fill: 169, payouts: 1, paid: 1252 },
    oct: { evals: 988, fill: 60, payouts: 1, paid: 2480 },
    nov: { evals: 1265, fill: 84, payouts: 2, paid: 6480 },
    dec: { evals: 13, fill: 0, payouts: 0, paid: 0 },
  },
  {
    package: 'LB Bundle $100,000 Cruise | 15 minis | 150 micros',
    jan: { evals: 1471, fill: 127, payouts: 1, paid: 4100 },
    feb: { evals: 4449, fill: 338, payouts: 12, paid: 48918 },
    mar: { evals: 4800, fill: 380, payouts: 22, paid: 75763 },
    apr: { evals: 12728, fill: 858, payouts: 14, paid: 101853 },
    may: { evals: 530, fill: 58, payouts: 0, paid: 0 },
    jun: { evals: 3835, fill: 247, payouts: 11, paid: 89948 },
    jul: { evals: 9355, fill: 480, payouts: 22, paid: 23168 },
    aug: { evals: 3793, fill: 298, payouts: 5, paid: 22594 },
    sep: { evals: 1783, fill: 208, payouts: 4, paid: 11949 },
    oct: { evals: 2262, fill: 282, payouts: 8, paid: 14490 },
    nov: { evals: 4205, fill: 182, payouts: 13, paid: 40091 },
    dec: { evals: 20, fill: 0, payouts: 0, paid: 0 },
  },
  {
    package: 'LB Bundle $300,000 Explode | 30 minis | 300 micros',
    jan: { evals: 748, fill: 0, payouts: 0, paid: 0 },
    feb: { evals: 4274, fill: 0, payouts: 1, paid: 42258 },
    mar: { evals: 1890, fill: 0, payouts: 8, paid: 0 },
    apr: { evals: 4702, fill: 100, payouts: 3, paid: 41448 },
    may: { evals: 2383, fill: 104, payouts: 1, paid: 1000 },
    jun: { evals: 700, fill: 0, payouts: 0, paid: 0 },
    jul: { evals: 1060, fill: 12, payouts: 0, paid: 0 },
    aug: { evals: 448, fill: 24, payouts: 1, paid: 6000 },
    sep: { evals: 275, fill: 20, payouts: 3, paid: 0 },
    oct: { evals: 678, fill: 20, payouts: 4, paid: 11400 },
    nov: { evals: 331, fill: 0, payouts: 4, paid: 0 },
    dec: { evals: 250, fill: 0, payouts: 0, paid: 0 },
  },
  {
    package: 'LB Bundle $200,000 Burst | 25 minis | 250 micros',
    jan: { evals: 53, fill: 0, payouts: 0, paid: 0 },
    feb: { evals: 489, fill: 10, payouts: 1, paid: 2100 },
    mar: { evals: 891, fill: 45, payouts: 3, paid: 8167 },
    apr: { evals: 2813, fill: 139, payouts: 2, paid: 8373 },
    may: { evals: 239, fill: 3, payouts: 1, paid: 1000 },
    jun: { evals: 2562, fill: 122, payouts: 8, paid: 18490 },
    jul: { evals: 1424, fill: 50, payouts: 0, paid: 0 },
    aug: { evals: 805, fill: 25, payouts: 3, paid: 11364 },
    sep: { evals: 200, fill: 15, payouts: 0, paid: 4782 },
    oct: { evals: 457, fill: 14, payouts: 1, paid: 0 },
    nov: { evals: 360, fill: 9, payouts: 1, paid: 1000 },
    dec: { evals: 5, fill: 0, payouts: 0, paid: 0 },
  },
  {
    package: 'LB Bundle $25,000 Aspire | 3 minis | 30 micros',
    jan: { evals: 444, fill: 48, payouts: 1, paid: 1000 },
    feb: { evals: 5487, fill: 537, payouts: 9, paid: 37303 },
    mar: { evals: 7459, fill: 733, payouts: 7, paid: 11040 },
    apr: { evals: 11942, fill: 810, payouts: 9, paid: 18469 },
    may: { evals: 28929, fill: 2298, payouts: 57, paid: 101981 },
    jun: { evals: 14944, fill: 1883, payouts: 3, paid: 53991 },
    jul: { evals: 6332, fill: 570, payouts: 9, paid: 10119 },
    aug: { evals: 4622, fill: 977, payouts: 4, paid: 11760 },
    sep: { evals: 2472, fill: 225, payouts: 4, paid: 4200 },
    oct: { evals: 1711, fill: 179, payouts: 2, paid: 1980 },
    nov: { evals: 3426, fill: 268, payouts: 5, paid: 1901 },
    dec: { evals: 14313, fill: 226, payouts: 14, paid: 49200 },
  },
];

export const mockRetentionRate: TReportRetentionRateData[] = [
  {
    date: 'Jan 2024',
    products: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 85.5,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 78.2,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 82.4,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 88.9,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 91.3,
    },
    products_previous: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 83.2,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 76.8,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 80.1,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 86.5,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 89.7,
    },
    products_previous_year: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 81.0,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 74.5,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 78.3,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 84.2,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 87.9,
    },
  },
  {
    date: 'Feb 2024',
    products: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 86.8,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 79.5,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 83.7,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 89.6,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 92.1,
    },
    products_previous: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 84.5,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 77.9,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 81.4,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 87.3,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 90.4,
    },
    products_previous_year: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 82.3,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 75.6,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 79.1,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 85.0,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 88.6,
    },
  },
  {
    date: 'Mar 2024',
    products: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 84.2,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 77.8,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 81.9,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 87.4,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 90.5,
    },
    products_previous: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 82.1,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 76.2,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 79.7,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 85.1,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 88.9,
    },
    products_previous_year: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 79.8,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 73.9,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 77.5,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 82.8,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 86.7,
    },
  },
  {
    date: 'Apr 2024',
    products: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 87.5,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 80.3,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 84.6,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 90.2,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 93.0,
    },
    products_previous: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 85.4,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 78.7,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 82.3,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 88.0,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 91.3,
    },
    products_previous_year: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 83.1,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 76.4,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 80.1,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 85.7,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 89.5,
    },
  },
  {
    date: 'May 2024',
    products: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 88.9,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 81.7,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 85.8,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 91.5,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 94.2,
    },
    products_previous: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 86.8,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 80.1,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 83.6,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 89.3,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 92.6,
    },
    products_previous_year: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 84.5,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 77.8,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 81.4,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 87.0,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 90.8,
    },
  },
  {
    date: 'Jun 2024',
    products: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 86.3,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 79.4,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 83.5,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 89.1,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 91.8,
    },
    products_previous: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 84.2,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 77.8,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 81.3,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 86.9,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 90.2,
    },
    products_previous_year: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 81.9,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 75.5,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 79.1,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 84.6,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 88.5,
    },
  },
  {
    date: 'Jul 2024',
    products: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 89.7,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 82.9,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 86.4,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 92.3,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 94.8,
    },
    products_previous: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 87.6,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 81.3,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 84.2,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 90.1,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 93.2,
    },
    products_previous_year: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 85.3,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 79.0,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 82.0,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 87.8,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 91.6,
    },
  },
  {
    date: 'Aug 2024',
    products: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 87.1,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 80.6,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 84.2,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 90.0,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 92.5,
    },
    products_previous: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 85.0,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 79.0,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 82.0,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 87.8,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 90.9,
    },
    products_previous_year: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 82.7,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 76.7,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 79.8,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 85.5,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 89.3,
    },
  },
  {
    date: 'Sep 2024',
    products: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 90.2,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 83.8,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 87.1,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 93.0,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 95.3,
    },
    products_previous: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 88.1,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 82.2,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 84.9,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 90.8,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 93.7,
    },
    products_previous_year: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 85.8,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 79.9,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 82.7,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 88.5,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 92.1,
    },
  },
  {
    date: 'Oct 2024',
    products: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 88.4,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 81.9,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 85.3,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 91.2,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 93.6,
    },
    products_previous: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 86.3,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 80.3,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 83.1,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 89.0,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 92.0,
    },
    products_previous_year: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 84.0,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 78.0,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 80.9,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 86.7,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 90.4,
    },
  },
  {
    date: 'Nov 2024',
    products: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 91.5,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 85.2,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 88.7,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 94.1,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 96.0,
    },
    products_previous: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 89.4,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 83.6,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 86.5,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 91.9,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 94.4,
    },
    products_previous_year: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 87.1,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 81.3,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 84.3,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 89.6,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 92.8,
    },
  },
  {
    date: 'Dec 2024',
    products: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 89.8,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 83.4,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 86.9,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 92.5,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 94.7,
    },
    products_previous: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 87.7,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 81.8,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 84.7,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 90.3,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 93.1,
    },
    products_previous_year: {
      '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 85.4,
      '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 79.5,
      '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 82.5,
      '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 88.0,
      '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 91.5,
    },
  },
];

export const mockRefundsByCustomerCountry: TReportRefundsByCustomerCountryData[] =
  [
    {
      date: '11/17/25',
      countries: {
        'United States': 800,
        Canada: 300,
        'United Kingdom': 200,
        Germany: 150,
        Australia: 100,
      },
      countries_previous: {
        'United States': 750,
        Canada: 280,
        'United Kingdom': 180,
        Germany: 140,
        Australia: 90,
      },
      countries_previous_year: {
        'United States': 700,
        Canada: 250,
        'United Kingdom': 160,
        Germany: 130,
        Australia: 80,
      },
    },
    {
      date: '11/18/25',
      countries: {
        'United States': 900,
        Canada: 350,
        'United Kingdom': 250,
        Germany: 180,
        Australia: 120,
      },
      countries_previous: {
        'United States': 850,
        Canada: 330,
        'United Kingdom': 230,
        Germany: 170,
        Australia: 110,
      },
      countries_previous_year: {
        'United States': 780,
        Canada: 300,
        'United Kingdom': 210,
        Germany: 150,
        Australia: 100,
      },
    },
    {
      date: '11/19/25',
      countries: {
        'United States': 1000,
        Canada: 400,
        'United Kingdom': 280,
        Germany: 200,
        Australia: 150,
      },
      countries_previous: {
        'United States': 950,
        Canada: 380,
        'United Kingdom': 260,
        Germany: 190,
        Australia: 140,
      },
      countries_previous_year: {
        'United States': 880,
        Canada: 350,
        'United Kingdom': 240,
        Germany: 170,
        Australia: 130,
      },
    },
    {
      date: '11/20/25',
      countries: {
        'United States': 700,
        Canada: 250,
        'United Kingdom': 180,
        Germany: 120,
        Australia: 80,
      },
      countries_previous: {
        'United States': 650,
        Canada: 230,
        'United Kingdom': 160,
        Germany: 110,
        Australia: 70,
      },
      countries_previous_year: {
        'United States': 600,
        Canada: 200,
        'United Kingdom': 140,
        Germany: 100,
        Australia: 60,
      },
    },
    {
      date: '11/21/25',
      countries: {
        'United States': 850,
        Canada: 320,
        'United Kingdom': 220,
        Germany: 160,
        Australia: 110,
      },
      countries_previous: {
        'United States': 800,
        Canada: 300,
        'United Kingdom': 200,
        Germany: 150,
        Australia: 100,
      },
      countries_previous_year: {
        'United States': 750,
        Canada: 280,
        'United Kingdom': 190,
        Germany: 140,
        Australia: 90,
      },
    },
    {
      date: '11/22/25',
      countries: {
        'United States': 950,
        Canada: 380,
        'United Kingdom': 260,
        Germany: 190,
        Australia: 130,
      },
      countries_previous: {
        'United States': 900,
        Canada: 360,
        'United Kingdom': 240,
        Germany: 180,
        Australia: 120,
      },
      countries_previous_year: {
        'United States': 850,
        Canada: 340,
        'United Kingdom': 220,
        Germany: 160,
        Australia: 110,
      },
    },
  ];

export const mockTaxByCustomerCountry: TReportTaxByCustomerCountryData[] = [
  {
    date: '11/17/25',
    countries: {
      'United States': 1200,
      Canada: 450,
      'United Kingdom': 300,
      Germany: 225,
      Australia: 150,
    },
    countries_previous: {
      'United States': 1125,
      Canada: 420,
      'United Kingdom': 270,
      Germany: 210,
      Australia: 135,
    },
    countries_previous_year: {
      'United States': 1050,
      Canada: 375,
      'United Kingdom': 240,
      Germany: 195,
      Australia: 120,
    },
  },
  {
    date: '11/18/25',
    countries: {
      'United States': 1350,
      Canada: 525,
      'United Kingdom': 375,
      Germany: 270,
      Australia: 180,
    },
    countries_previous: {
      'United States': 1275,
      Canada: 495,
      'United Kingdom': 345,
      Germany: 255,
      Australia: 165,
    },
    countries_previous_year: {
      'United States': 1170,
      Canada: 450,
      'United Kingdom': 315,
      Germany: 225,
      Australia: 150,
    },
  },
  {
    date: '11/19/25',
    countries: {
      'United States': 1500,
      Canada: 600,
      'United Kingdom': 420,
      Germany: 300,
      Australia: 225,
    },
    countries_previous: {
      'United States': 1425,
      Canada: 570,
      'United Kingdom': 390,
      Germany: 285,
      Australia: 210,
    },
    countries_previous_year: {
      'United States': 1320,
      Canada: 525,
      'United Kingdom': 360,
      Germany: 255,
      Australia: 195,
    },
  },
  {
    date: '11/20/25',
    countries: {
      'United States': 1050,
      Canada: 375,
      'United Kingdom': 270,
      Germany: 180,
      Australia: 120,
    },
    countries_previous: {
      'United States': 975,
      Canada: 345,
      'United Kingdom': 240,
      Germany: 165,
      Australia: 105,
    },
    countries_previous_year: {
      'United States': 900,
      Canada: 300,
      'United Kingdom': 210,
      Germany: 150,
      Australia: 90,
    },
  },
  {
    date: '11/21/25',
    countries: {
      'United States': 1275,
      Canada: 480,
      'United Kingdom': 330,
      Germany: 240,
      Australia: 165,
    },
    countries_previous: {
      'United States': 1200,
      Canada: 450,
      'United Kingdom': 300,
      Germany: 225,
      Australia: 150,
    },
    countries_previous_year: {
      'United States': 1125,
      Canada: 420,
      'United Kingdom': 285,
      Germany: 210,
      Australia: 135,
    },
  },
  {
    date: '11/22/25',
    countries: {
      'United States': 1425,
      Canada: 570,
      'United Kingdom': 390,
      Germany: 285,
      Australia: 195,
    },
    countries_previous: {
      'United States': 1350,
      Canada: 540,
      'United Kingdom': 360,
      Germany: 270,
      Australia: 180,
    },
    countries_previous_year: {
      'United States': 1250,
      Canada: 500,
      'United Kingdom': 340,
      Germany: 250,
      Australia: 165,
    },
  },
];

export const mockTaxByCustomerState: TReportTaxByCustomerStateData[] = [
  {
    date: '11/17/25',
    states: {
      California: 800,
      'New York': 600,
      Texas: 400,
      Florida: 300,
      Illinois: 200,
    },
    states_previous: {
      California: 750,
      'New York': 550,
      Texas: 380,
      Florida: 280,
      Illinois: 180,
    },
    states_previous_year: {
      California: 700,
      'New York': 500,
      Texas: 350,
      Florida: 250,
      Illinois: 160,
    },
  },
  {
    date: '11/18/25',
    states: {
      California: 900,
      'New York': 700,
      Texas: 450,
      Florida: 350,
      Illinois: 250,
    },
    states_previous: {
      California: 850,
      'New York': 650,
      Texas: 420,
      Florida: 320,
      Illinois: 230,
    },
    states_previous_year: {
      California: 780,
      'New York': 600,
      Texas: 390,
      Florida: 290,
      Illinois: 210,
    },
  },
  {
    date: '11/19/25',
    states: {
      California: 1000,
      'New York': 800,
      Texas: 500,
      Florida: 400,
      Illinois: 300,
    },
    states_previous: {
      California: 950,
      'New York': 750,
      Texas: 470,
      Florida: 380,
      Illinois: 280,
    },
    states_previous_year: {
      California: 880,
      'New York': 700,
      Texas: 440,
      Florida: 350,
      Illinois: 260,
    },
  },
  {
    date: '11/20/25',
    states: {
      California: 700,
      'New York': 500,
      Texas: 350,
      Florida: 250,
      Illinois: 150,
    },
    states_previous: {
      California: 650,
      'New York': 470,
      Texas: 330,
      Florida: 230,
      Illinois: 140,
    },
    states_previous_year: {
      California: 600,
      'New York': 440,
      Texas: 310,
      Florida: 210,
      Illinois: 130,
    },
  },
  {
    date: '11/21/25',
    states: {
      California: 850,
      'New York': 650,
      Texas: 400,
      Florida: 300,
      Illinois: 200,
    },
    states_previous: {
      California: 800,
      'New York': 600,
      Texas: 380,
      Florida: 280,
      Illinois: 180,
    },
    states_previous_year: {
      California: 750,
      'New York': 550,
      Texas: 350,
      Florida: 250,
      Illinois: 160,
    },
  },
  {
    date: '11/22/25',
    states: {
      California: 950,
      'New York': 750,
      Texas: 450,
      Florida: 350,
      Illinois: 250,
    },
    states_previous: {
      California: 900,
      'New York': 700,
      Texas: 420,
      Florida: 320,
      Illinois: 230,
    },
    states_previous_year: {
      California: 850,
      'New York': 650,
      Texas: 400,
      Florida: 300,
      Illinois: 220,
    },
  },
];

export const mockAverageAmountByProductsBreakdown: TReportAverageAmountByProductsBreakdownData[] =
  [
    {
      product_id: 3,
      product_name:
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds',
      average_amount: 250.75,
      average_count_of_purchases: 1,
    },
    {
      product_id: 5,
      product_name: '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown',
      average_amount: 300.5,
      average_count_of_purchases: 2,
    },
    {
      product_id: 6,
      product_name: '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown',
      average_amount: 280.0,
      average_count_of_purchases: 2,
    },
    {
      product_id: 7,
      product_name: '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown',
      average_amount: 260.0,
      average_count_of_purchases: 2,
    },
    {
      product_id: 8,
      product_name: '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown',
      average_amount: 240.0,
      average_count_of_purchases: 2,
    },
  ];

export const mockAveragePaymentsByUserGroup: TReportAveragePaymentsByUserGroupData[] =
  [
    {
      date: '11/01/25',
      user_groups: {
        '15% summer June and July 2025': 150.25,
        '20% commision': 175.5,
        'Darrell 15%': 200.75,
      },
      user_groups_previous: {
        '15% summer June and July 2025': 145.0,
        '20% commision': 170.0,
        'Darrell 15%': 195.0,
      },
      user_groups_previous_year: {
        '15% summer June and July 2025': 140.0,
        '20% commision': 165.0,
        'Darrell 15%': 190.0,
      },
    },
    {
      date: '11/02/25',
      user_groups: {
        '15% summer June and July 2025': 155.0,
        '20% commision': 180.0,
        'Darrell 15%': 205.0,
      },
      user_groups_previous: {
        '15% summer June and July 2025': 150.0,
        '20% commision': 175.0,
        'Darrell 15%': 200.0,
      },
      user_groups_previous_year: {
        '15% summer June and July 2025': 145.0,
        '20% commision': 170.0,
        'Darrell 15%': 195.0,
      },
    },
    {
      date: '11/03/25',
      user_groups: {
        '15% summer June and July 2025': 160.25,
        '20% commision': 185.5,
        'Darrell 15%': 210.75,
      },
      user_groups_previous: {
        '15% summer June and July 2025': 155.0,
        '20% commision': 180.0,
        'Darrell 15%': 205.0,
      },
      user_groups_previous_year: {
        '15% summer June and July 2025': 150.0,
        '20% commision': 175.0,
        'Darrell 15%': 200.0,
      },
    },
    {
      date: '11/04/25',
      user_groups: {
        '15% summer June and July 2025': 165.25,
        '20% commision': 190.5,
        'Darrell 15%': 215.75,
      },
      user_groups_previous: {
        '15% summer June and July 2025': 160.0,
        '20% commision': 185.0,
        'Darrell 15%': 210.0,
      },
      user_groups_previous_year: {
        '15% summer June and July 2025': 155.0,
        '20% commision': 180.0,
        'Darrell 15%': 205.0,
      },
    },
    {
      date: '11/05/25',
      user_groups: {
        '15% summer June and July 2025': 170.0,
        '20% commision': 195.0,
        'Darrell 15%': 220.0,
      },
      user_groups_previous: {
        '15% summer June and July 2025': 165.0,
        '20% commision': 190.0,
        'Darrell 15%': 215.0,
      },
      user_groups_previous_year: {
        '15% summer June and July 2025': 160.0,
        '20% commision': 185.0,
        'Darrell 15%': 210.0,
      },
    },
    {
      date: '11/06/25',
      user_groups: {
        '15% summer June and July 2025': 175.5,
        '20% commision': 200.0,
        'Darrell 15%': 225.5,
      },
      user_groups_previous: {
        '15% summer June and July 2025': 170.0,
        '20% commision': 195.0,
        'Darrell 15%': 220.0,
      },
      user_groups_previous_year: {
        '15% summer June and July 2025': 165.0,
        '20% commision': 190.0,
        'Darrell 15%': 215.0,
      },
    },
    {
      date: '11/07/25',
      user_groups: {
        '15% summer June and July 2025': 180.0,
        '20% commision': 205.0,
        'Darrell 15%': 230.0,
      },
      user_groups_previous: {
        '15% summer June and July 2025': 175.0,
        '20% commision': 200.0,
        'Darrell 15%': 225.0,
      },
      user_groups_previous_year: {
        '15% summer June and July 2025': 170.0,
        '20% commision': 195.0,
        'Darrell 15%': 220.0,
      },
    },
    {
      date: '11/08/25',
      user_groups: {
        '15% summer June and July 2025': 185.25,
        '20% commision': 210.5,
        'Darrell 15%': 235.75,
      },
      user_groups_previous: {
        '15% summer June and July 2025': 180.0,
        '20% commision': 205.0,
        'Darrell 15%': 230.0,
      },
      user_groups_previous_year: {
        '15% summer June and July 2025': 175.0,
        '20% commision': 200.0,
        'Darrell 15%': 225.0,
      },
    },
    {
      date: '11/09/25',
      user_groups: {
        '15% summer June and July 2025': 190.0,
        '20% commision': 215.0,
        'Darrell 15%': 240.0,
      },
      user_groups_previous: {
        '15% summer June and July 2025': 185.0,
        '20% commision': 210.0,
        'Darrell 15%': 235.0,
      },
      user_groups_previous_year: {
        '15% summer June and July 2025': 180.0,
        '20% commision': 205.0,
        'Darrell 15%': 230.0,
      },
    },
    {
      date: '11/10/25',
      user_groups: {
        '15% summer June and July 2025': 195.5,
        '20% commision': 220.0,
        'Darrell 15%': 245.5,
      },
      user_groups_previous: {
        '15% summer June and July 2025': 190.0,
        '20% commision': 215.0,
        'Darrell 15%': 240.0,
      },
      user_groups_previous_year: {
        '15% summer June and July 2025': 185.0,
        '20% commision': 210.0,
        'Darrell 15%': 235.0,
      },
    },
    {
      date: '11/11/25',
      user_groups: {
        '15% summer June and July 2025': 200.0,
        '20% commision': 225.0,
        'Darrell 15%': 250.0,
      },
      user_groups_previous: {
        '15% summer June and July 2025': 195.0,
        '20% commision': 220.0,
        'Darrell 15%': 245.0,
      },
      user_groups_previous_year: {
        '15% summer June and July 2025': 190.0,
        '20% commision': 215.0,
        'Darrell 15%': 240.0,
      },
    },
    {
      date: '11/12/25',
      user_groups: {
        '15% summer June and July 2025': 205.25,
        '20% commision': 230.5,
        'Darrell 15%': 255.75,
      },
      user_groups_previous: {
        '15% summer June and July 2025': 200.0,
        '20% commision': 225.0,
        'Darrell 15%': 250.0,
      },
      user_groups_previous_year: {
        '15% summer June and July 2025': 195.0,
        '20% commision': 220.0,
        'Darrell 15%': 245.0,
      },
    },
  ];

export const mockAverageLifetimeValueCohortAnalysis: TReportAverageLifetimeValueCohortAnalysisData[] =
  [
    { cohort_period: 'Week 1', average_lifetime_value: 1250.5 },
    { cohort_period: 'Week 2', average_lifetime_value: 1180.75 },
    { cohort_period: 'Week 3', average_lifetime_value: 1320.25 },
    { cohort_period: 'Week 4', average_lifetime_value: 1450.0 },
    { cohort_period: 'Week 5', average_lifetime_value: 1290.8 },
    { cohort_period: 'Week 6', average_lifetime_value: 1380.5 },
    { cohort_period: 'Week 7', average_lifetime_value: 1420.75 },
    { cohort_period: 'Week 8', average_lifetime_value: 1510.25 },
    { cohort_period: 'Week 9', average_lifetime_value: 1350.0 },
    { cohort_period: 'Week 10', average_lifetime_value: 1480.5 },
    { cohort_period: 'Week 11', average_lifetime_value: 1560.75 },
    { cohort_period: 'Week 12', average_lifetime_value: 1620.0 },
  ];

export const mockChurnRate: TReportChurnRateData[] = [
  {
    date: 'Jan 2025',
    products: {
      'RITHM - LUCKS - ECZ, 50k': 8,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 23,
      'RITHM - CRUISE - ECZ, 150k': 80,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 139,
    },
    products_previous: {
      'RITHM - LUCKS - ECZ, 50k': 5,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 20,
      'RITHM - CRUISE - ECZ, 150k': 75,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 130,
    },
  },
  {
    date: 'Feb 2025',
    products: {
      'RITHM - LUCKS - ECZ, 50k': 0,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 10,
      'RITHM - CRUISE - ECZ, 150k': 11,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 4,
    },
    products_previous: {
      'RITHM - LUCKS - ECZ, 50k': 2,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 12,
      'RITHM - CRUISE - ECZ, 150k': 10,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 6,
    },
  },
  {
    date: 'Mar 2025',
    products: {
      'RITHM - LUCKS - ECZ, 50k': 10,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 17,
      'RITHM - CRUISE - ECZ, 150k': 10,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 17,
    },
    products_previous: {
      'RITHM - LUCKS - ECZ, 50k': 8,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 15,
      'RITHM - CRUISE - ECZ, 150k': 12,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 20,
    },
  },
  {
    date: 'Apr 2025',
    products: {
      'RITHM - LUCKS - ECZ, 50k': 10,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 22,
      'RITHM - CRUISE - ECZ, 150k': 10,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 22,
    },
    products_previous: {
      'RITHM - LUCKS - ECZ, 50k': 12,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 20,
      'RITHM - CRUISE - ECZ, 150k': 8,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 25,
    },
  },
  {
    date: 'May 2025',
    products: {
      'RITHM - LUCKS - ECZ, 50k': 20,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 10,
      'RITHM - CRUISE - ECZ, 150k': 42,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 30,
    },
    products_previous: {
      'RITHM - LUCKS - ECZ, 50k': 18,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 12,
      'RITHM - CRUISE - ECZ, 150k': 40,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 28,
    },
  },
  {
    date: 'Jun 2025',
    products: {
      'RITHM - LUCKS - ECZ, 50k': 4,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 25,
      'RITHM - CRUISE - ECZ, 150k': 89,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 143,
    },
    products_previous: {
      'RITHM - LUCKS - ECZ, 50k': 6,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 22,
      'RITHM - CRUISE - ECZ, 150k': 85,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 140,
    },
  },
  {
    date: 'Jul 2025',
    products: {
      'RITHM - LUCKS - ECZ, 50k': 13,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 22,
      'RITHM - CRUISE - ECZ, 150k': 10,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 11,
    },
    products_previous: {
      'RITHM - LUCKS - ECZ, 50k': 10,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 25,
      'RITHM - CRUISE - ECZ, 150k': 12,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 10,
    },
  },
  {
    date: 'Aug 2025',
    products: {
      'RITHM - LUCKS - ECZ, 50k': 10,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 22,
      'RITHM - CRUISE - ECZ, 150k': 72,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 30,
    },
    products_previous: {
      'RITHM - LUCKS - ECZ, 50k': 12,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 20,
      'RITHM - CRUISE - ECZ, 150k': 70,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 32,
    },
  },
  {
    date: 'Sep 2025',
    products: {
      'RITHM - LUCKS - ECZ, 50k': 10,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 11,
      'RITHM - CRUISE - ECZ, 150k': 42,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 38,
    },
    products_previous: {
      'RITHM - LUCKS - ECZ, 50k': 8,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 13,
      'RITHM - CRUISE - ECZ, 150k': 40,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 35,
    },
  },
  {
    date: 'Oct 2025',
    products: {
      'RITHM - LUCKS - ECZ, 50k': 11,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 23,
      'RITHM - CRUISE - ECZ, 150k': 71,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 4,
    },
    products_previous: {
      'RITHM - LUCKS - ECZ, 50k': 10,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 25,
      'RITHM - CRUISE - ECZ, 150k': 68,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 6,
    },
  },
  {
    date: 'Nov 2025',
    products: {
      'RITHM - LUCKS - ECZ, 50k': 4,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 6,
      'RITHM - CRUISE - ECZ, 150k': 42,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 12,
    },
    products_previous: {
      'RITHM - LUCKS - ECZ, 50k': 5,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 8,
      'RITHM - CRUISE - ECZ, 150k': 40,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 10,
    },
  },
  {
    date: 'Dec 2025',
    products: {
      'RITHM - LUCKS - ECZ, 50k': 2,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 9,
      'RITHM - CRUISE - ECZ, 150k': 17,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 13,
    },
    products_previous: {
      'RITHM - LUCKS - ECZ, 50k': 3,
      'RITHM - LUCKS - ECZ, 50k | TRAILING DRAWDOWN': 10,
      'RITHM - CRUISE - ECZ, 150k': 15,
      'RITHM - CRUISE - ECZ, 150k | TRAILING DRAWDOWN': 12,
    },
  },
];

export const mockNumberOfPaymentsByBillingPlan: TReportNumberOfPaymentsByBillingPlanData[] =
  [
    {
      date: '11/01/25',
      products: {
        [productTypeOptions[0].value]: 45,
        [productTypeOptions[1].value]: 38,
        [productTypeOptions[2].value]: 28,
        [productTypeOptions[3].value]: 22,
      },
      products_previous: {
        [productTypeOptions[0].value]: 42,
        [productTypeOptions[1].value]: 35,
        [productTypeOptions[2].value]: 25,
        [productTypeOptions[3].value]: 20,
      },
      products_previous_year: {
        [productTypeOptions[0].value]: 40,
        [productTypeOptions[1].value]: 30,
        [productTypeOptions[2].value]: 22,
        [productTypeOptions[3].value]: 18,
      },
    },
    {
      date: '11/02/25',
      products: {
        [productTypeOptions[0].value]: 52,
        [productTypeOptions[1].value]: 43,
        [productTypeOptions[2].value]: 33,
        [productTypeOptions[3].value]: 26,
      },
      products_previous: {
        [productTypeOptions[0].value]: 47,
        [productTypeOptions[1].value]: 39,
        [productTypeOptions[2].value]: 29,
        [productTypeOptions[3].value]: 23,
      },
      products_previous_year: {
        [productTypeOptions[0].value]: 42,
        [productTypeOptions[1].value]: 34,
        [productTypeOptions[2].value]: 26,
        [productTypeOptions[3].value]: 21,
      },
    },
    {
      date: '11/03/25',
      products: {
        [productTypeOptions[0].value]: 58,
        [productTypeOptions[1].value]: 47,
        [productTypeOptions[2].value]: 37,
        [productTypeOptions[3].value]: 29,
      },
      products_previous: {
        [productTypeOptions[0].value]: 53,
        [productTypeOptions[1].value]: 43,
        [productTypeOptions[2].value]: 33,
        [productTypeOptions[3].value]: 26,
      },
      products_previous_year: {
        [productTypeOptions[0].value]: 48,
        [productTypeOptions[1].value]: 39,
        [productTypeOptions[2].value]: 30,
        [productTypeOptions[3].value]: 24,
      },
    },
    {
      date: '11/04/25',
      products: {
        [productTypeOptions[0].value]: 63,
        [productTypeOptions[1].value]: 51,
        [productTypeOptions[2].value]: 41,
        [productTypeOptions[3].value]: 32,
      },
      products_previous: {
        [productTypeOptions[0].value]: 58,
        [productTypeOptions[1].value]: 46,
        [productTypeOptions[2].value]: 37,
        [productTypeOptions[3].value]: 29,
      },
      products_previous_year: {
        [productTypeOptions[0].value]: 53,
        [productTypeOptions[1].value]: 42,
        [productTypeOptions[2].value]: 34,
        [productTypeOptions[3].value]: 27,
      },
    },
    {
      date: '11/05/25',
      products: {
        [productTypeOptions[0].value]: 67,
        [productTypeOptions[1].value]: 54,
        [productTypeOptions[2].value]: 44,
        [productTypeOptions[3].value]: 34,
      },
      products_previous: {
        [productTypeOptions[0].value]: 62,
        [productTypeOptions[1].value]: 49,
        [productTypeOptions[2].value]: 40,
        [productTypeOptions[3].value]: 31,
      },
      products_previous_year: {
        [productTypeOptions[0].value]: 57,
        [productTypeOptions[1].value]: 45,
        [productTypeOptions[2].value]: 37,
        [productTypeOptions[3].value]: 29,
      },
    },
    {
      date: '11/06/25',
      products: {
        [productTypeOptions[0].value]: 71,
        [productTypeOptions[1].value]: 57,
        [productTypeOptions[2].value]: 47,
        [productTypeOptions[3].value]: 36,
      },
      products_previous: {
        [productTypeOptions[0].value]: 66,
        [productTypeOptions[1].value]: 52,
        [productTypeOptions[2].value]: 43,
        [productTypeOptions[3].value]: 33,
      },
      products_previous_year: {
        [productTypeOptions[0].value]: 61,
        [productTypeOptions[1].value]: 48,
        [productTypeOptions[2].value]: 40,
        [productTypeOptions[3].value]: 31,
      },
    },
    {
      date: '11/07/25',
      products: {
        [productTypeOptions[0].value]: 74,
        [productTypeOptions[1].value]: 59,
        [productTypeOptions[2].value]: 49,
        [productTypeOptions[3].value]: 37,
      },
      products_previous: {
        [productTypeOptions[0].value]: 69,
        [productTypeOptions[1].value]: 54,
        [productTypeOptions[2].value]: 45,
        [productTypeOptions[3].value]: 34,
      },
      products_previous_year: {
        [productTypeOptions[0].value]: 64,
        [productTypeOptions[1].value]: 50,
        [productTypeOptions[2].value]: 42,
        [productTypeOptions[3].value]: 32,
      },
    },
  ];

export const mockConversionRate: TReportConversionRateData[] = [
  { payment: 'nmi-com', conversion_rate: 85.5 },
  { payment: 'paypal-express', conversion_rate: 82.3 },
  { payment: 'stripe', conversion_rate: 88.9 },
  { payment: 'stripe-apple-pay', conversion_rate: 75.2 },
];

export const mockCancelFeedback: TReportCancelFeedbackData[] = [
  {
    reason: 'Competition is better',
    total_cancel_feedback: 238,
  },
  {
    reason: 'Content I want is not available',
    total_cancel_feedback: 267,
  },
  {
    reason: "Don't use it enough",
    total_cancel_feedback: 189,
  },
  {
    reason: 'Found a better price elsewhere',
    total_cancel_feedback: 145,
  },
  {
    reason: 'Other',
    total_cancel_feedback: 2820,
  },
];

export const reportData: TOption[] = [
  {
    label: 'Users - New users by month',
    value: ReportType.USERS_NEW_USERS_BY_MONTH,
  },
  {
    label: 'Users - Active users with no active accounts',
    value: ReportType.USERS_ACTIVE_USERS_WITH_NO_ACTIVE_ACCOUNTS,
  },
  {
    label: 'Users - Active Users expiring before account expiry',
    value: ReportType.USERS_ACTIVE_USERS_EXPIRING_BEFORE_ACCOUNT_EXPIRY,
  },
  {
    label: 'Users - Active users with Top of Book',
    value: ReportType.USERS_ACTIVE_USERS_WITH_TOP_OF_BOOK,
  },
  {
    label: 'Users - Active users with Extra Session',
    value: ReportType.USERS_ACTIVE_USERS_WITH_EXTRA_SESSION,
  },
  {
    label: 'Users - Active users with Eurex',
    value: ReportType.USERS_ACTIVE_USERS_WITH_EUREX,
  },
  {
    label: 'Users - Churn Rate by Date',
    value: ReportType.USERS_CHURN_RATE_BY_DATE,
  },
  {
    label: 'Users - Blacklisted Users',
    value: ReportType.USERS_BLACKLISTED_USERS,
  },
  {
    label: 'Users - Active Users by Period',
    value: ReportType.ACTIVE_USERS_BY_PERIOD,
  },
  {
    label: 'Users - Active Users by Product Categories',
    value: ReportType.ACTIVE_USERS_BY_PRODUCT_CATEGORIES,
  },
  {
    label: 'Users - Active Users by Products',
    value: ReportType.ACTIVE_USERS_BY_PRODUCTS,
  },
  {
    label: 'EVAL - Account by date > PA > Payout (NEW - JODY)',
    value: ReportType.EVAL_ACCOUNT_BY_DATE_PA_PAYOUT_NEW_JODY,
  },
  {
    label: 'Old - Affiliate Clicks - number of affiliate program clicks',
    value: ReportType.OLD_AFFILIATE_CLICKS,
  },
  {
    label: 'Old - Affiliate Commission Amount By User',
    value: ReportType.OLD_AFFILIATE_COMMISSIONS_BY_USER,
  },
  {
    label: 'Old - Affiliate Commissions - affiliate program commissions',
    value: ReportType.OLD_AFFILIATE_COMMISSIONS,
  },
  {
    label:
      'Old - Affiliate Commissions By Product - affiliate program commissions',
    value: ReportType.OLD_AFFILIATE_COMMISSIONS_BY_PRODUCTS,
  },
  {
    label: 'Old - Affiliate Payout Amount by User',
    value: ReportType.OLD_AFFILIATE_PAYOUT_AMOUNT,
  },
  {
    label: 'Old - Affiliate Sales Number - number of sales by affiliate',
    value: ReportType.OLD_AFFILIATE_SALES_NUMBER,
  },
  // {
  //   label: 'NEW - Affiliate Clicks - number of affiliate program clicks',
  //   value: ReportType.NEW_AFFILIATE_CLICKS,
  // },
  // {
  //   label: 'NEW - Affiliate Commissions By User',
  //   value: ReportType.NEW_AFFILIATE_COMMISSIONS_BY_USER,
  // },
  // {
  //   label: 'NEW - Affiliate Commissions - affiliate program commissions',
  //   value: ReportType.NEW_AFFILIATE_COMMISSIONS,
  // },
  // {
  //   label:
  //     'NEW - Affiliate Commissions By Product - affiliate program commissions',
  //   value: ReportType.NEW_AFFILIATE_COMMISSIONS_BY_PRODUCTS,
  // },
  // {
  //   label: 'NEW - Affiliate Payout Amount by User',
  //   value: ReportType.NEW_AFFILIATE_PAYOUT_AMOUNT,
  // },
  // {
  //   label: 'NEW - Affiliate Sales Number - number of sales by affiliate',
  //   value: ReportType.NEW_AFFILIATE_SALES_NUMBER,
  // },
  {
    label: 'EVAL - New / Renewal By Month',
    value: ReportType.EVAL_NEW_RENEWAL_BY_MONTH,
  },
  {
    label: 'PA - $xxx Daily P/L',
    value: ReportType.PA_DAILY_PL,
  },
  {
    label: 'EVAL - Eval Analysis by creation date',
    value: ReportType.EVAL_EVAL_ANALYSIS_BY_CREATION_DATE,
  },
  {
    label: 'Bundles > PA Accounts',
    value: ReportType.BUNDLES_PA_ACCOUNTS,
  },
  {
    label: 'PA - Daily P/L hitting 30%+ of target',
    value: ReportType.PA_DAILY_PL_HITTING_30_PERCENT_OF_TARGET,
  },
  {
    label: 'PA - New Accounts by Date',
    value: ReportType.PA_NEW_ACCOUNTS_BY_DATE,
  },
  {
    label: 'PA - Active Lifetime PA',
    value: ReportType.PA_ACTIVE_LIFETIME_PA,
  },
  {
    label: 'PA - Profitable Traders',
    value: ReportType.PA_PROFITABLE_TRADERS,
  },
  {
    label: 'PA - Pnl Analysis',
    value: ReportType.PA_PNL_ANALYSIS,
  },
  {
    label: 'PA - Resets',
    value: ReportType.PA_RESETS,
  },
  {
    label: 'PA - Type / Active / Payouts / Addons (v2)',
    value: ReportType.PA_TYPE_ACTIVE_PAYOUTS_ADDONS_V2,
  },
  {
    label: 'PA - New / Renewal / Reset By Month',
    value: ReportType.PA_NEW_RENEWAL_RESET_BY_MONTH,
  },
  {
    label: 'PA - Profitable Traders (V2)',
    value: ReportType.PA_PROFITABLE_TRADERS_V2,
  },
  {
    label: 'Payouts - Totals Report',
    value: ReportType.PAYOUTS_TOTALS_REPORT,
  },
  {
    label: 'Payouts - PA Analysis by date',
    value: ReportType.PAYOUTS_PA_ANALYSIS_BY_DATE,
  },
  {
    label: 'Express Account > PA Refunds',
    value: ReportType.EXPRESS_ACCOUNT_PA_REFUNDS,
  },
  {
    label: 'Leaderboard',
    value: ReportType.LEADERBOARD,
  },
  {
    label: 'Staff - Staff Freebies by Month',
    value: ReportType.STAFF_STAFF_FREEBIES_BY_MONTH,
  },
  {
    label: 'Amount of Rebills',
    value: ReportType.AMOUNT_OF_REBILLS,
  },
  {
    label: 'Average Amount By Products Breakdown',
    value: ReportType.AVERAGE_AMOUNT_BY_PRODUCTS_BREAKDOWN,
  },
  {
    label:
      'Average Lifetime Value (Cohort Analysis) - report includes only user who did at least one time payment',
    value: ReportType.AVERAGE_LIFETIME_VALUE_COHORT_ANALYSIS,
  },
  {
    label: 'Average Payment By User Group',
    value: ReportType.AVERAGE_PAYMENTS_BY_USER_GROUP,
  },
  {
    label: 'Cancel Feedback',
    value: ReportType.CANCEL_FEEDBACK,
  },
  {
    label: 'Churn Rate - Number of users who becomes inactive in given period',
    value: ReportType.CHURN_RATE,
  },
  {
    label: 'Conversion Rate By Payment System Breakdown',
    value: ReportType.CONVERSION_RATE_BY_PAYMENT_SYSTEM_BREAKDOWN,
  },
  {
    label:
      'Count Of Cancellations - Number Of Cancelled Recurring Subscriptions By Period',
    value: ReportType.COUNT_OF_CANCELLATIONS,
  },
  {
    label: 'Count Of Pending Invoices',
    value: ReportType.COUNT_OF_PENDING_INVOICES,
  },
  {
    label: 'Count Of Signups By Country',
    value: ReportType.COUNT_OF_SIGNUPS_BY_COUNTRY,
  },
  {
    label: 'Count Of Product Purchase',
    value: ReportType.COUNT_OF_PRODUCT_PURCHASE,
  },
  {
    label: 'Count Of Product Purchase By Payment System Breakdown',
    value: ReportType.COUNT_OF_PRODUCT_PURCHASE_BY_PAYMENT_SYSTEM_BREAKDOWN,
  },
  {
    label: 'Count Of User Signups - including pending records',
    value: ReportType.COUNT_OF_USER_SIGNUPS,
  },
  {
    label: 'Credits Spent By Products Breakdown',
    value: ReportType.CREDITS_SPENT_BY_PRODUCTS_BREAKDOWN,
  },
  {
    label:
      'Download By Files Breakdown - only files downloaded by registered users is taken to account',
    value: ReportType.DOWNLOADS_BY_FILES_BREAKDOWN,
  },
  {
    label: 'Income Report - payments minus refunds',
    value: ReportType.INCOME_REPORT,
  },
  {
    label: 'Invoices By Signup Form',
    value: ReportType.INVOICES_BY_SIGNUP_FORM,
  },
  {
    label: 'Number Of Payments By Billing Plan',
    value: ReportType.NUMBER_OF_PAYMENTS_BY_BILLING_PLAN,
  },
  {
    label: 'Number Of Rebills',
    value: ReportType.NUMBER_OF_REBILLS,
  },
  {
    label: 'Payments Distribution By Customer Country',
    value: ReportType.PAYMENTS_DISTRIBUTION_BY_CUSTOMER_COUNTRY,
  },
  {
    label: 'Payments By Customer City',
    value: ReportType.PAYMENTS_BY_CUSTOMER_CITY,
  },
  {
    label: 'Payments By Customer Country',
    value: ReportType.PAYMENTS_BY_CUSTOMER_COUNTRY,
  },
  {
    label: 'Payments By New Vs Existing Members',
    value: ReportType.PAYMENTS_BY_NEW_VS_EXISTING_MEMBERS,
  },
  {
    label: 'Payments By Used Coupon',
    value: ReportType.PAYMENTS_BY_USED_COUPON,
  },
  {
    label: 'Payments By User Group',
    value: ReportType.PAYMENTS_BY_USER_GROUP,
  },
  {
    label: 'Payments By Payment System Breakdown',
    value: ReportType.PAYMENTS_BY_PAYMENT_SYSTEM_BREAKDOWN,
  },
  {
    label: 'Payments By Product Categories Breakdown',
    value: ReportType.PAYMENTS_BY_PRODUCT_CATEGORIES_BREAKDOWN,
  },
  {
    label: 'Payments By Products Breakdown',
    value: ReportType.PAYMENTS_BY_PRODUCTS_BREAKDOWN,
  },
  {
    label: 'Payments By Signup Form Breakdown',
    value: ReportType.PAYMENTS_BY_SIGNUP_FORM_BREAKDOWN,
  },
  {
    label: 'Payments Minus Refunds By Customer Country',
    value: ReportType.PAYMENTS_MINUS_REFUNDS_BY_CUSTOMER_COUNTRY,
  },
  {
    label: 'Payments Minus Refunds By Customer State',
    value: ReportType.PAYMENTS_MINUS_REFUNDS_BY_CUSTOMER_STATE,
  },
  {
    label: 'Payments Vs Refunds',
    value: ReportType.PAYMENTS_VS_REFUNDS,
  },
  {
    label:
      'Product Conversion - Percentage of Users who purchased Product B after Product A',
    value: ReportType.PRODUCT_CONVERSION,
  },
  {
    label: 'Refunds Distribution By Customer Country',
    value: ReportType.REFUNDS_DISTRIBUTION_BY_CUSTOMER_COUNTRY,
  },
  {
    label: 'Refunds Rate',
    value: ReportType.REFUNDS_RATE,
  },
  {
    label: 'Refunds By Customer Country',
    value: ReportType.REFUNDS_BY_CUSTOMER_COUNTRY,
  },
  {
    label: 'Refunds By Used Coupon',
    value: ReportType.REFUNDS_BY_USED_COUPON,
  },
  {
    label: 'Refunds By Payment System Breakdown',
    value: ReportType.REFUNDS_BY_PAYMENT_SYSTEM_BREAKDOWN,
  },
  {
    label: 'Refunds By Product Categories Breakdown',
    value: ReportType.REFUNDS_BY_PRODUCT_CATEGORIES_BREAKDOWN,
  },
  {
    label: 'Refunds By Products Breakdown',
    value: ReportType.REFUNDS_BY_PRODUCTS_BREAKDOWN,
  },
  {
    label: 'Retention Rate - Number of cancel on each billing cycle',
    value: ReportType.RETENTION_RATE,
  },
  {
    label:
      'Rolling Conversion - Percentage of users who convert from free to paid within given amount of days',
    value: ReportType.ROLLING_CONVERSION,
  },
  {
    label: 'Tax Report',
    value: ReportType.TAX_REPORT,
  },
  {
    label: 'Tax By Customer Country',
    value: ReportType.TAX_BY_CUSTOMER_COUNTRY,
  },
  {
    label: 'Tax By Customer State',
    value: ReportType.TAX_BY_CUSTOMER_STATE,
  },
  {
    label: 'User Demographics - number of users per region',
    value: ReportType.USER_DEMOGRAPHICS,
  },
  {
    label: 'User Distribution By Custom Field',
    value: ReportType.USER_DISTRIBUTION_BY_CUSTOM_FIELD,
  },
  {
    label: 'User Distribution By Custom Field By Date',
    value: ReportType.USER_DISTRIBUTION_BY_CUSTOM_FIELD_BY_DATE,
  },
  {
    label: 'User Lifetime',
    value: ReportType.USER_LIFETIME,
  },
  {
    label: 'Users By User Groups - number of users per groups',
    value: ReportType.USERS_BY_USER_GROUPS,
  },
];

export const evalAccountByDatePaPayoutNewJody: TEvalAccountByDatePaPayoutNewJodyTable[] =
  [
    {
      packageName:
        '(CM) Competition | $200K 3 Contracts |NO Refunds | Will Not qualify for PA|',
      evalAccounts: 546,
      uniqueEvalUsers: 448,
      qualifiedToPa: 0,
      uniquePaUser: 0,
      paStillActive: 0,
      uniqueActivePaUsers: 0,
      receivedPayouts: 0,
      payoutTotal: 0,
      paToPayout: 0,
    },
    {
      packageName:
        '(CM) Competition | $200K 3 Contracts |NO Refunds | Will Not qualify for PA|',
      evalAccounts: 546,
      uniqueEvalUsers: 448,
      qualifiedToPa: 0,
      uniquePaUser: 0,
      paStillActive: 0,
      uniqueActivePaUsers: 0,
      receivedPayouts: 0,
      payoutTotal: 0,
      paToPayout: 0,
    },
    {
      packageName:
        '(CM) Competition | $200K 3 Contracts |NO Refunds | Will Not qualify for PA|',
      evalAccounts: 546,
      uniqueEvalUsers: 448,
      qualifiedToPa: 0,
      uniquePaUser: 0,
      paStillActive: 0,
      uniqueActivePaUsers: 0,
      receivedPayouts: 0,
      payoutTotal: 0,
      paToPayout: 0,
    },
    {
      packageName:
        '(CM) Competition | $200K 3 Contracts |NO Refunds | Will Not qualify for PA|',
      evalAccounts: 546,
      uniqueEvalUsers: 448,
      qualifiedToPa: 0,
      uniquePaUser: 0,
      paStillActive: 0,
      uniqueActivePaUsers: 0,
      receivedPayouts: 0,
      payoutTotal: 0,
      paToPayout: 0,
    },
    {
      packageName:
        '(CM) Competition | $200K 3 Contracts |NO Refunds | Will Not qualify for PA|',
      evalAccounts: 546,
      uniqueEvalUsers: 448,
      qualifiedToPa: 0,
      uniquePaUser: 0,
      paStillActive: 0,
      uniqueActivePaUsers: 0,
      receivedPayouts: 0,
      payoutTotal: 0,
      paToPayout: 0,
    },
    {
      packageName:
        '(CM) Competition | $200K 3 Contracts |NO Refunds | Will Not qualify for PA|',
      evalAccounts: 546,
      uniqueEvalUsers: 448,
      qualifiedToPa: 0,
      uniquePaUser: 0,
      paStillActive: 0,
      uniqueActivePaUsers: 0,
      receivedPayouts: 0,
      payoutTotal: 0,
      paToPayout: 0,
    },
    {
      packageName:
        '(CM) Competition | $200K 3 Contracts |NO Refunds | Will Not qualify for PA|',
      evalAccounts: 546,
      uniqueEvalUsers: 448,
      qualifiedToPa: 0,
      uniquePaUser: 0,
      paStillActive: 0,
      uniqueActivePaUsers: 0,
      receivedPayouts: 0,
      payoutTotal: 0,
      paToPayout: 0,
    },
    {
      packageName:
        '(CM) Competition | $200K 3 Contracts |NO Refunds | Will Not qualify for PA|',
      evalAccounts: 546,
      uniqueEvalUsers: 448,
      qualifiedToPa: 0,
      uniquePaUser: 0,
      paStillActive: 0,
      uniqueActivePaUsers: 0,
      receivedPayouts: 0,
      payoutTotal: 0,
      paToPayout: 0,
    },
    {
      packageName:
        '(CM) Competition | $200K 3 Contracts |NO Refunds | Will Not qualify for PA|',
      evalAccounts: 546,
      uniqueEvalUsers: 448,
      qualifiedToPa: 0,
      uniquePaUser: 0,
      paStillActive: 0,
      uniqueActivePaUsers: 0,
      receivedPayouts: 0,
      payoutTotal: 0,
      paToPayout: 0,
    },
  ];

export const payoutsTotalsReport: TPayoutsTotalsReportTable[] = [
  {
    packages: '12 Contract | $ 100,000 Climb | Investor',
    totalPaAccounts: 301,
    totalPayouts: 201,
    payoutUniqueAccounts: 143,
    payoutUniqueUsers: 104,
    totalPayout: 610443,
    accountsWithPayout1: 68,
    accountsWithPayout2: 51,
    accountsWithPayout3: 16,
    accountsWithPayout4: 6,
    accountsWithPayout5: 9,
    accountsWithPayout6: 0,
    accountsWithPayout7: 3,
  },
  {
    packages: '12 Contract | $ 100,000 Climb | Investor',
    totalPaAccounts: 301,
    totalPayouts: 201,
    payoutUniqueAccounts: 143,
    payoutUniqueUsers: 104,
    totalPayout: 610443,
    accountsWithPayout1: 68,
    accountsWithPayout2: 51,
    accountsWithPayout3: 16,
    accountsWithPayout4: 6,
    accountsWithPayout5: 9,
    accountsWithPayout6: 0,
    accountsWithPayout7: 3,
  },
  {
    packages: '12 Contract | $ 100,000 Climb | Investor',
    totalPaAccounts: 301,
    totalPayouts: 201,
    payoutUniqueAccounts: 143,
    payoutUniqueUsers: 104,
    totalPayout: 610443,
    accountsWithPayout1: 68,
    accountsWithPayout2: 51,
    accountsWithPayout3: 16,
    accountsWithPayout4: 6,
    accountsWithPayout5: 9,
    accountsWithPayout6: 0,
    accountsWithPayout7: 3,
  },
  {
    packages: '12 Contract | $ 100,000 Climb | Investor',
    totalPaAccounts: 301,
    totalPayouts: 201,
    payoutUniqueAccounts: 143,
    payoutUniqueUsers: 104,
    totalPayout: 610443,
    accountsWithPayout1: 68,
    accountsWithPayout2: 51,
    accountsWithPayout3: 16,
    accountsWithPayout4: 6,
    accountsWithPayout5: 9,
    accountsWithPayout6: 0,
    accountsWithPayout7: 3,
  },
  {
    packages: '12 Contract | $ 100,000 Climb | Investor',
    totalPaAccounts: 301,
    totalPayouts: 201,
    payoutUniqueAccounts: 143,
    payoutUniqueUsers: 104,
    totalPayout: 610443,
    accountsWithPayout1: 68,
    accountsWithPayout2: 51,
    accountsWithPayout3: 16,
    accountsWithPayout4: 6,
    accountsWithPayout5: 9,
    accountsWithPayout6: 0,
    accountsWithPayout7: 3,
  },
  {
    packages: '12 Contract | $ 100,000 Climb | Investor',
    totalPaAccounts: 301,
    totalPayouts: 201,
    payoutUniqueAccounts: 143,
    payoutUniqueUsers: 104,
    totalPayout: 610443,
    accountsWithPayout1: 68,
    accountsWithPayout2: 51,
    accountsWithPayout3: 16,
    accountsWithPayout4: 6,
    accountsWithPayout5: 9,
    accountsWithPayout6: 0,
    accountsWithPayout7: 3,
  },
  {
    packages: '12 Contract | $ 100,000 Climb | Investor',
    totalPaAccounts: 301,
    totalPayouts: 201,
    payoutUniqueAccounts: 143,
    payoutUniqueUsers: 104,
    totalPayout: 610443,
    accountsWithPayout1: 68,
    accountsWithPayout2: 51,
    accountsWithPayout3: 16,
    accountsWithPayout4: 6,
    accountsWithPayout5: 9,
    accountsWithPayout6: 0,
    accountsWithPayout7: 3,
  },
  {
    packages: '12 Contract | $ 100,000 Climb | Investor',
    totalPaAccounts: 301,
    totalPayouts: 201,
    payoutUniqueAccounts: 143,
    payoutUniqueUsers: 104,
    totalPayout: 610443,
    accountsWithPayout1: 68,
    accountsWithPayout2: 51,
    accountsWithPayout3: 16,
    accountsWithPayout4: 6,
    accountsWithPayout5: 9,
    accountsWithPayout6: 0,
    accountsWithPayout7: 3,
  },
  {
    packages: '12 Contract | $ 100,000 Climb | Investor',
    totalPaAccounts: 301,
    totalPayouts: 201,
    payoutUniqueAccounts: 143,
    payoutUniqueUsers: 104,
    totalPayout: 610443,
    accountsWithPayout1: 68,
    accountsWithPayout2: 51,
    accountsWithPayout3: 16,
    accountsWithPayout4: 6,
    accountsWithPayout5: 9,
    accountsWithPayout6: 0,
    accountsWithPayout7: 3,
  },
  {
    packages: '12 Contract | $ 100,000 Climb | Investor',
    totalPaAccounts: 301,
    totalPayouts: 201,
    payoutUniqueAccounts: 143,
    payoutUniqueUsers: 104,
    totalPayout: 610443,
    accountsWithPayout1: 68,
    accountsWithPayout2: 51,
    accountsWithPayout3: 16,
    accountsWithPayout4: 6,
    accountsWithPayout5: 9,
    accountsWithPayout6: 0,
    accountsWithPayout7: 3,
  },
  {
    packages: 'Total',
    totalPaAccounts: 301,
    totalPayouts: 201,
    payoutUniqueAccounts: 143,
    payoutUniqueUsers: 104,
    totalPayout: 610443,
    accountsWithPayout1: 68,
    accountsWithPayout2: 51,
    accountsWithPayout3: 16,
    accountsWithPayout4: 6,
    accountsWithPayout5: 9,
    accountsWithPayout6: 0,
    accountsWithPayout7: 3,
  },
];

export const payoutsAmountReport: TPayoutsAmountReportTable[] = [
  { month: '12 Contract | $ 100,000 Climb | Investor', amount: 610443 },
  { month: '12 Contract | $ 100,000 Climb | Investor', amount: 610443 },
  { month: '12 Contract | $ 100,000 Climb | Investor', amount: 610443 },
  { month: '12 Contract | $ 100,000 Climb | Investor', amount: 610443 },
  { month: '12 Contract | $ 100,000 Climb | Investor', amount: 610443 },
  { month: '12 Contract | $ 100,000 Climb | Investor', amount: 610443 },
  { month: '12 Contract | $ 100,000 Climb | Investor', amount: 610443 },
  { month: '12 Contract | $ 100,000 Climb | Investor', amount: 610443 },
  { month: '12 Contract | $ 100,000 Climb | Investor', amount: 610443 },
  { month: '12 Contract | $ 100,000 Climb | Investor', amount: 610443 },
  { month: '12 Contract | $ 100,000 Climb | Investor', amount: 610443 },
  { month: '12 Contract | $ 100,000 Climb | Investor', amount: 610443 },
  { month: 'Total', amount: 610443 },
];

export const mockIncome: TReportIncomeData[] = [
  {
    date: '11/01/25',
    payment_amount: 1200,
    payment_amount_previous: 1100,
    payment_amount_previous_year: 1000,
    total_refunds: 150,
    net_income: 1050,
  },
  {
    date: '11/02/25',
    payment_amount: 1350,
    payment_amount_previous: 1250,
    payment_amount_previous_year: 1150,
    total_refunds: 180,
    net_income: 1170,
  },
  {
    date: '11/03/25',
    payment_amount: 1500,
    payment_amount_previous: 1400,
    payment_amount_previous_year: 1300,
    total_refunds: 210,
    net_income: 1290,
  },
  {
    date: '11/04/25',
    payment_amount: 1650,
    payment_amount_previous: 1550,
    payment_amount_previous_year: 1450,
    total_refunds: 240,
    net_income: 1410,
  },
  {
    date: '11/05/25',
    payment_amount: 1800,
    payment_amount_previous: 1700,
    payment_amount_previous_year: 1600,
    total_refunds: 270,
    net_income: 1530,
  },
  {
    date: '11/06/25',
    payment_amount: 1950,
    payment_amount_previous: 1850,
    payment_amount_previous_year: 1750,
    total_refunds: 300,
    net_income: 1650,
  },
  {
    date: '11/07/25',
    payment_amount: 2100,
    payment_amount_previous: 2000,
    payment_amount_previous_year: 1900,
    total_refunds: 330,
    net_income: 1770,
  },
];

export const mockRefundsByPaymentSystemBreakdown: TReportRefundsByPaymentSystemBreakdownData[] =
  [
    {
      date: '11/01/25',
      payment_systems: {
        PayPal: 2500,
        Stripe: 3500,
        'PayPal Express': 1500,
        'Network Merchants Inc': 1000,
        ApplePay: 800,
        'Free Signup': 200,
      },
      payment_systems_previous: {
        PayPal: 2400,
        Stripe: 3300,
        'PayPal Express': 1450,
        'Network Merchants Inc': 950,
        ApplePay: 750,
        'Free Signup': 180,
      },
      payment_systems_previous_year: {
        PayPal: 2200,
        Stripe: 3000,
        'PayPal Express': 1300,
        'Network Merchants Inc': 900,
        ApplePay: 700,
        'Free Signup': 150,
      },
    },
    {
      date: '11/02/25',
      payment_systems: {
        PayPal: 2700,
        Stripe: 3800,
        'PayPal Express': 1600,
        'Network Merchants Inc': 1100,
        ApplePay: 900,
        'Free Signup': 220,
      },
      payment_systems_previous: {
        PayPal: 2600,
        Stripe: 3600,
        'PayPal Express': 1550,
        'Network Merchants Inc': 1050,
        ApplePay: 850,
        'Free Signup': 200,
      },
      payment_systems_previous_year: {
        PayPal: 2400,
        Stripe: 3300,
        'PayPal Express': 1450,
        'Network Merchants Inc': 1000,
        ApplePay: 800,
        'Free Signup': 180,
      },
    },
    {
      date: '11/03/25',
      payment_systems: {
        PayPal: 2900,
        Stripe: 4200,
        'PayPal Express': 1800,
        'Network Merchants Inc': 1200,
        ApplePay: 1000,
        'Free Signup': 250,
      },
      payment_systems_previous: {
        PayPal: 2800,
        Stripe: 4000,
        'PayPal Express': 1700,
        'Network Merchants Inc': 1150,
        ApplePay: 950,
        'Free Signup': 230,
      },
      payment_systems_previous_year: {
        PayPal: 2600,
        Stripe: 3700,
        'PayPal Express': 1600,
        'Network Merchants Inc': 1100,
        ApplePay: 900,
        'Free Signup': 200,
      },
    },
    {
      date: '11/04/25',
      payment_systems: {
        PayPal: 2300,
        Stripe: 3200,
        'PayPal Express': 1400,
        'Network Merchants Inc': 900,
        ApplePay: 700,
        'Free Signup': 180,
      },
      payment_systems_previous: {
        PayPal: 2200,
        Stripe: 3100,
        'PayPal Express': 1350,
        'Network Merchants Inc': 850,
        ApplePay: 650,
        'Free Signup': 160,
      },
      payment_systems_previous_year: {
        PayPal: 2000,
        Stripe: 2800,
        'PayPal Express': 1200,
        'Network Merchants Inc': 800,
        ApplePay: 600,
        'Free Signup': 140,
      },
    },
    {
      date: '11/05/25',
      payment_systems: {
        PayPal: 3100,
        Stripe: 4500,
        'PayPal Express': 1900,
        'Network Merchants Inc': 1300,
        ApplePay: 1100,
        'Free Signup': 270,
      },
      payment_systems_previous: {
        PayPal: 3000,
        Stripe: 4300,
        'PayPal Express': 1850,
        'Network Merchants Inc': 1250,
        ApplePay: 1050,
        'Free Signup': 250,
      },
      payment_systems_previous_year: {
        PayPal: 2800,
        Stripe: 4000,
        'PayPal Express': 1700,
        'Network Merchants Inc': 1200,
        ApplePay: 1000,
        'Free Signup': 220,
      },
    },
    {
      date: '11/06/25',
      payment_systems: {
        PayPal: 3100,
        Stripe: 4500,
        'PayPal Express': 1900,
        'Network Merchants Inc': 1300,
        ApplePay: 1100,
        'Free Signup': 270,
      },
      payment_systems_previous: {
        PayPal: 3000,
        Stripe: 4300,
        'PayPal Express': 1850,
        'Network Merchants Inc': 1250,
        ApplePay: 1050,
        'Free Signup': 250,
      },
      payment_systems_previous_year: {
        PayPal: 2800,
        Stripe: 4000,
        'PayPal Express': 1700,
        'Network Merchants Inc': 1200,
        ApplePay: 1000,
        'Free Signup': 220,
      },
    },
    {
      date: '11/07/25',
      payment_systems: {
        PayPal: 3300,
        Stripe: 4800,
        'PayPal Express': 2100,
        'Network Merchants Inc': 1400,
        ApplePay: 1200,
        'Free Signup': 300,
      },
      payment_systems_previous: {
        PayPal: 3200,
        Stripe: 4600,
        'PayPal Express': 2000,
        'Network Merchants Inc': 1350,
        ApplePay: 1150,
        'Free Signup': 280,
      },
      payment_systems_previous_year: {
        PayPal: 3000,
        Stripe: 4300,
        'PayPal Express': 1800,
        'Network Merchants Inc': 1300,
        ApplePay: 1100,
        'Free Signup': 250,
      },
    },
  ];

export const mockPaymentsByProductCategoriesBreakdown: TReportPaymentsByProductCategoriesBreakdownData[] =
  [
    {
      date: '11/17/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 18500.0,
        'Products with Commission': 32450.75,
        Turbos: 15200.0,
        'All Monthly Evaluations': 24800.5,
        'Add-ons': 8920.25,
        'Full Membership': 12340.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 17200.0,
        'Products with Commission': 30100.0,
        Turbos: 14000.0,
        'All Monthly Evaluations': 23500.0,
        'Add-ons': 8200.0,
        'Full Membership': 11500.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 15000.0,
        'Products with Commission': 26000.0,
        Turbos: 12000.0,
        'All Monthly Evaluations': 20000.0,
        'Add-ons': 7000.0,
        'Full Membership': 10000.0,
      },
    },
    {
      date: '11/18/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 19200.0,
        'Products with Commission': 34100.0,
        Turbos: 16300.0,
        'All Monthly Evaluations': 25900.0,
        'Add-ons': 9350.0,
        'Full Membership': 13100.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 17800.0,
        'Products with Commission': 31500.0,
        Turbos: 14800.0,
        'All Monthly Evaluations': 24200.0,
        'Add-ons': 8600.0,
        'Full Membership': 12000.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 15500.0,
        'Products with Commission': 27000.0,
        Turbos: 12500.0,
        'All Monthly Evaluations': 20500.0,
        'Add-ons': 7300.0,
        'Full Membership': 10500.0,
      },
    },
    {
      date: '11/19/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 20100.0,
        'Products with Commission': 36200.0,
        Turbos: 17400.0,
        'All Monthly Evaluations': 27100.0,
        'Add-ons': 9800.0,
        'Full Membership': 14200.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 18500.0,
        'Products with Commission': 33000.0,
        Turbos: 15500.0,
        'All Monthly Evaluations': 25000.0,
        'Add-ons': 9000.0,
        'Full Membership': 12800.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 16000.0,
        'Products with Commission': 28000.0,
        Turbos: 13000.0,
        'All Monthly Evaluations': 21000.0,
        'Add-ons': 7600.0,
        'Full Membership': 11000.0,
      },
    },
    {
      date: '11/20/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 21300.0,
        'Products with Commission': 38500.0,
        Turbos: 18600.0,
        'All Monthly Evaluations': 28400.0,
        'Add-ons': 10350.0,
        'Full Membership': 15100.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 19300.0,
        'Products with Commission': 34800.0,
        Turbos: 16400.0,
        'All Monthly Evaluations': 26000.0,
        'Add-ons': 9500.0,
        'Full Membership': 13500.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 16800.0,
        'Products with Commission': 29500.0,
        Turbos: 13800.0,
        'All Monthly Evaluations': 22000.0,
        'Add-ons': 8000.0,
        'Full Membership': 11500.0,
      },
    },
    {
      date: '11/21/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 22100.0,
        'Products with Commission': 40200.0,
        Turbos: 19500.0,
        'All Monthly Evaluations': 29600.0,
        'Add-ons': 10800.0,
        'Full Membership': 15900.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 20000.0,
        'Products with Commission': 36500.0,
        Turbos: 17200.0,
        'All Monthly Evaluations': 27200.0,
        'Add-ons': 9900.0,
        'Full Membership': 14200.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 17500.0,
        'Products with Commission': 31000.0,
        Turbos: 14500.0,
        'All Monthly Evaluations': 23000.0,
        'Add-ons': 8400.0,
        'Full Membership': 12000.0,
      },
    },
    {
      date: '11/22/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 23400.0,
        'Products with Commission': 42800.0,
        Turbos: 20700.0,
        'All Monthly Evaluations': 31200.0,
        'Add-ons': 11500.0,
        'Full Membership': 16800.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 21200.0,
        'Products with Commission': 38800.0,
        Turbos: 18300.0,
        'All Monthly Evaluations': 28700.0,
        'Add-ons': 10500.0,
        'Full Membership': 15000.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 18500.0,
        'Products with Commission': 33000.0,
        Turbos: 15500.0,
        'All Monthly Evaluations': 24500.0,
        'Add-ons': 9000.0,
        'Full Membership': 12800.0,
      },
    },
    {
      date: '11/23/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 24600.0,
        'Products with Commission': 45100.0,
        Turbos: 21800.0,
        'All Monthly Evaluations': 32800.0,
        'Add-ons': 12100.0,
        'Full Membership': 17600.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 22300.0,
        'Products with Commission': 40800.0,
        Turbos: 19200.0,
        'All Monthly Evaluations': 30100.0,
        'Add-ons': 11000.0,
        'Full Membership': 15800.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 19500.0,
        'Products with Commission': 35000.0,
        Turbos: 16500.0,
        'All Monthly Evaluations': 26000.0,
        'Add-ons': 9500.0,
        'Full Membership': 13500.0,
      },
    },
  ];

export const mockRefundsByProductCategoriesBreakdown: TReportRefundsByProductCategoriesBreakdownData[] =
  [
    {
      date: '11/17/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 1850.0,
        'Products with Commission': 3245.75,
        Turbos: 1520.0,
        'All Monthly Evaluations': 2480.5,
        'Add-ons': 892.25,
        'Full Membership': 1234.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 1720.0,
        'Products with Commission': 3010.0,
        Turbos: 1400.0,
        'All Monthly Evaluations': 2350.0,
        'Add-ons': 820.0,
        'Full Membership': 1150.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 1500.0,
        'Products with Commission': 2600.0,
        Turbos: 1200.0,
        'All Monthly Evaluations': 2000.0,
        'Add-ons': 700.0,
        'Full Membership': 1000.0,
      },
    },
    {
      date: '11/18/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 1920.0,
        'Products with Commission': 3410.0,
        Turbos: 1630.0,
        'All Monthly Evaluations': 2590.0,
        'Add-ons': 935.0,
        'Full Membership': 1310.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 1780.0,
        'Products with Commission': 3150.0,
        Turbos: 1480.0,
        'All Monthly Evaluations': 2420.0,
        'Add-ons': 860.0,
        'Full Membership': 1200.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 1550.0,
        'Products with Commission': 2700.0,
        Turbos: 1250.0,
        'All Monthly Evaluations': 2050.0,
        'Add-ons': 730.0,
        'Full Membership': 1050.0,
      },
    },
    {
      date: '11/19/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 2010.0,
        'Products with Commission': 3620.0,
        Turbos: 1740.0,
        'All Monthly Evaluations': 2710.0,
        'Add-ons': 980.0,
        'Full Membership': 1420.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 1850.0,
        'Products with Commission': 3300.0,
        Turbos: 1550.0,
        'All Monthly Evaluations': 2500.0,
        'Add-ons': 900.0,
        'Full Membership': 1280.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 1600.0,
        'Products with Commission': 2800.0,
        Turbos: 1300.0,
        'All Monthly Evaluations': 2100.0,
        'Add-ons': 760.0,
        'Full Membership': 1100.0,
      },
    },
    {
      date: '11/20/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 2130.0,
        'Products with Commission': 3850.0,
        Turbos: 1860.0,
        'All Monthly Evaluations': 2840.0,
        'Add-ons': 1035.0,
        'Full Membership': 1510.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 1930.0,
        'Products with Commission': 3480.0,
        Turbos: 1640.0,
        'All Monthly Evaluations': 2600.0,
        'Add-ons': 950.0,
        'Full Membership': 1350.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 1680.0,
        'Products with Commission': 2900.0,
        Turbos: 1350.0,
        'All Monthly Evaluations': 2200.0,
        'Add-ons': 800.0,
        'Full Membership': 1150.0,
      },
    },
    {
      date: '11/21/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 2260.0,
        'Products with Commission': 4100.0,
        Turbos: 1990.0,
        'All Monthly Evaluations': 2980.0,
        'Add-ons': 1090.0,
        'Full Membership': 1620.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 2030.0,
        'Products with Commission': 3680.0,
        Turbos: 1750.0,
        'All Monthly Evaluations': 2750.0,
        'Add-ons': 1000.0,
        'Full Membership': 1450.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 1750.0,
        'Products with Commission': 3000.0,
        Turbos: 1400.0,
        'All Monthly Evaluations': 2300.0,
        'Add-ons': 850.0,
        'Full Membership': 1200.0,
      },
    },
    {
      date: '11/22/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 2390.0,
        'Products with Commission': 4360.0,
        Turbos: 2120.0,
        'All Monthly Evaluations': 3130.0,
        'Add-ons': 1150.0,
        'Full Membership': 1730.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 2150.0,
        'Products with Commission': 3880.0,
        Turbos: 1870.0,
        'All Monthly Evaluations': 2870.0,
        'Add-ons': 1050.0,
        'Full Membership': 1500.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 1850.0,
        'Products with Commission': 3300.0,
        Turbos: 1550.0,
        'All Monthly Evaluations': 2450.0,
        'Add-ons': 900.0,
        'Full Membership': 1280.0,
      },
    },
    {
      date: '11/23/25',
      product_categories: {
        'Active Leeloo Traders Only (Sale)': 2460.0,
        'Products with Commission': 4510.0,
        Turbos: 2180.0,
        'All Monthly Evaluations': 3280.0,
        'Add-ons': 1210.0,
        'Full Membership': 1760.0,
      },
      product_categories_previous: {
        'Active Leeloo Traders Only (Sale)': 2230.0,
        'Products with Commission': 4080.0,
        Turbos: 1920.0,
        'All Monthly Evaluations': 3010.0,
        'Add-ons': 1100.0,
        'Full Membership': 1580.0,
      },
      product_categories_previous_year: {
        'Active Leeloo Traders Only (Sale)': 1950.0,
        'Products with Commission': 3500.0,
        Turbos: 1650.0,
        'All Monthly Evaluations': 2600.0,
        'Add-ons': 950.0,
        'Full Membership': 1350.0,
      },
    },
  ];

export const mockRefundsByProductsBreakdown: TReportRefundsByProductsBreakdownData[] =
  [
    {
      date: '11/17/25',
      products: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2450.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3210.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 4580.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 3820.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 2940.0,
      },
      products_previous: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2300.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3000.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 4300.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 3600.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 2750.0,
      },
      products_previous_year: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2000.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 2600.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 3800.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 3200.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 2400.0,
      },
    },
    {
      date: '11/18/25',
      products: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2630.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3450.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 4820.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 4010.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3120.0,
      },
      products_previous: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2480.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3250.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 4550.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 3780.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 2900.0,
      },
      products_previous_year: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2150.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 2800.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 4000.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 3350.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 2550.0,
      },
    },
    {
      date: '11/19/25',
      products: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2810.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3680.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 5120.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 4250.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3340.0,
      },
      products_previous: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2650.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3480.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 4850.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 4020.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3120.0,
      },
      products_previous_year: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2300.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3000.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 4200.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 3500.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 2700.0,
      },
    },
    {
      date: '11/20/25',
      products: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2990.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3920.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 5450.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 4520.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3560.0,
      },
      products_previous: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2820.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3700.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 5150.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 4280.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3350.0,
      },
      products_previous_year: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2450.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3200.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 4450.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 3700.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 2900.0,
      },
    },
    {
      date: '11/21/25',
      products: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 3170.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 4150.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 5780.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 4800.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3780.0,
      },
      products_previous: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2990.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3920.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 5450.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 4520.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3560.0,
      },
      products_previous_year: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2600.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3400.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 4700.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 3900.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3100.0,
      },
    },
    {
      date: '11/22/25',
      products: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 3350.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 4380.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 6100.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 5070.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3990.0,
      },
      products_previous: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 3170.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 4150.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 5780.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 4800.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3780.0,
      },
      products_previous_year: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2750.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3600.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 4950.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 4100.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3250.0,
      },
    },
    {
      date: '11/23/25',
      products: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 3530.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 4620.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 6420.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 5340.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 4200.0,
      },
      products_previous: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 3350.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 4380.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 6100.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 5070.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3990.0,
      },
      products_previous_year: {
        '(3) Rithmic | Leeloo Express | 14 Days | 12 Contract | No Refunds': 2900.0,
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 3800.0,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 5200.0,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 4300.0,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 3400.0,
      },
    },
  ];

export const mockDownloadByFilesBreakdown: TReportDownloadByFilesBreakdownData[] =
  [
    {
      date: '11/01/25',
      files: {
        'image1.png': 120,
        'image2.png': 95,
      },
      files_previous: {
        'image1.png': 110,
        'image2.png': 85,
      },
      files_previous_year: {
        'image1.png': 100,
        'image2.png': 75,
      },
    },
    {
      date: '11/02/25',
      files: {
        'image1.png': 135,
        'image2.png': 105,
      },
      files_previous: {
        'image1.png': 125,
        'image2.png': 95,
      },
      files_previous_year: {
        'image1.png': 115,
        'image2.png': 85,
      },
    },
    {
      date: '11/03/25',
      files: {
        'image1.png': 150,
        'image2.png': 115,
      },
      files_previous: {
        'image1.png': 140,
        'image2.png': 105,
      },
      files_previous_year: {
        'image1.png': 130,
        'image2.png': 95,
      },
    },
    {
      date: '11/04/25',
      files: {
        'image1.png': 165,
        'image2.png': 125,
      },
      files_previous: {
        'image1.png': 155,
        'image2.png': 115,
      },
      files_previous_year: {
        'image1.png': 145,
        'image2.png': 105,
      },
    },
    {
      date: '11/05/25',
      files: {
        'image1.png': 180,
        'image2.png': 135,
      },
      files_previous: {
        'image1.png': 170,
        'image2.png': 125,
      },
      files_previous_year: {
        'image1.png': 160,
        'image2.png': 115,
      },
    },
    {
      date: '11/06/25',
      files: {
        'image1.png': 195,
        'image2.png': 145,
      },
      files_previous: {
        'image1.png': 185,
        'image2.png': 135,
      },
      files_previous_year: {
        'image1.png': 175,
        'image2.png': 125,
      },
    },
    {
      date: '11/07/25',
      files: {
        'image1.png': 210,
        'image2.png': 155,
      },
      files_previous: {
        'image1.png': 200,
        'image2.png': 145,
      },
      files_previous_year: {
        'image1.png': 190,
        'image2.png': 135,
      },
    },
  ];

export const mockCreditsSpentByProductsBreakdown: TReportCreditsSpentByProductsBreakdownData[] =
  [
    {
      date: '11/01/25',
      products: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 120,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 95,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 75,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 60,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 45,
      },
      products_previous: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 110,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 85,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 65,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 50,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 35,
      },
      products_previous_year: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 100,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 75,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 55,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 40,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 25,
      },
    },
    {
      date: '11/02/25',
      products: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 135,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 105,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 85,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 70,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 55,
      },
      products_previous: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 125,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 95,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 75,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 60,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 45,
      },
      products_previous_year: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 115,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 85,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 65,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 50,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 35,
      },
    },
    {
      date: '11/03/25',
      products: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 150,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 115,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 95,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 80,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 65,
      },
      products_previous: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 140,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 105,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 85,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 70,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 55,
      },
      products_previous_year: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 130,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 95,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 75,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 60,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 45,
      },
    },
    {
      date: '11/04/25',
      products: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 165,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 125,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 105,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 90,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 75,
      },
      products_previous: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 155,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 115,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 95,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 80,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 65,
      },
      products_previous_year: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 145,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 105,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 85,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 70,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 55,
      },
    },
    {
      date: '11/05/25',
      products: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 180,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 135,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 115,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 100,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 85,
      },
      products_previous: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 170,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 125,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 105,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 90,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 75,
      },
      products_previous_year: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 160,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 115,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 95,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 80,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 65,
      },
    },
    {
      date: '11/06/25',
      products: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 195,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 145,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 125,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 110,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 95,
      },
      products_previous: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 185,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 135,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 115,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 100,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 85,
      },
      products_previous_year: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 175,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 125,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 105,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 90,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 75,
      },
    },
    {
      date: '11/07/25',
      products: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 210,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 155,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 135,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 120,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 105,
      },
      products_previous: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 200,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 145,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 125,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 110,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 95,
      },
      products_previous_year: {
        '(5) Rithmic | Aspire | 3ct, 25k | Trailing Drawdown': 190,
        '(6) Rithmic | Launch | 8ct, 50k | Trailing Drawdown': 135,
        '(7) Rithmic | Climb | 12ct, 100k | Trailing Drawdown': 115,
        '(8) Rithmic | Cruise | 15ct, 150k | Trailing Drawdown': 100,
        '(9) Rithmic | Burst | 25ct, 250k | Trailing Drawdown': 85,
      },
    },
  ];

export const mockInvoicesBySignupForm: TReportInvoicesBySignupFormData[] = [
  {
    date: '11/01/25',
    signup_forms: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 45,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 32,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 28,
      'Standard Signup Form': 67,
      'Premium Signup Form': 23,
    },
    signup_forms_previous: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 40,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 28,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 25,
      'Standard Signup Form': 60,
      'Premium Signup Form': 20,
    },
    signup_forms_previous_year: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 35,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 24,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 22,
      'Standard Signup Form': 55,
      'Premium Signup Form': 18,
    },
  },
  {
    date: '11/02/25',
    signup_forms: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 52,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 38,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 33,
      'Standard Signup Form': 74,
      'Premium Signup Form': 26,
    },
    signup_forms_previous: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 47,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 33,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 29,
      'Standard Signup Form': 67,
      'Premium Signup Form': 23,
    },
    signup_forms_previous_year: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 42,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 29,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 26,
      'Standard Signup Form': 62,
      'Premium Signup Form': 21,
    },
  },
  {
    date: '11/03/25',
    signup_forms: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 58,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 42,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 37,
      'Standard Signup Form': 81,
      'Premium Signup Form': 29,
    },
    signup_forms_previous: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 53,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 37,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 33,
      'Standard Signup Form': 74,
      'Premium Signup Form': 26,
    },
    signup_forms_previous_year: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 48,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 33,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 30,
      'Standard Signup Form': 69,
      'Premium Signup Form': 24,
    },
  },
  {
    date: '11/04/25',
    signup_forms: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 63,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 46,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 41,
      'Standard Signup Form': 88,
      'Premium Signup Form': 32,
    },
    signup_forms_previous: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 58,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 41,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 37,
      'Standard Signup Form': 81,
      'Premium Signup Form': 29,
    },
    signup_forms_previous_year: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 53,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 37,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 34,
      'Standard Signup Form': 76,
      'Premium Signup Form': 27,
    },
  },
  {
    date: '11/05/25',
    signup_forms: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 67,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 49,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 44,
      'Standard Signup Form': 94,
      'Premium Signup Form': 34,
    },
    signup_forms_previous: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 62,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 44,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 40,
      'Standard Signup Form': 87,
      'Premium Signup Form': 31,
    },
    signup_forms_previous_year: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 57,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 40,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 37,
      'Standard Signup Form': 82,
      'Premium Signup Form': 29,
    },
  },
  {
    date: '11/06/25',
    signup_forms: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 71,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 52,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 47,
      'Standard Signup Form': 99,
      'Premium Signup Form': 36,
    },
    signup_forms_previous: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 66,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 47,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 43,
      'Standard Signup Form': 92,
      'Premium Signup Form': 33,
    },
    signup_forms_previous_year: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 61,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 43,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 40,
      'Standard Signup Form': 87,
      'Premium Signup Form': 31,
    },
  },
  {
    date: '11/07/25',
    signup_forms: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 74,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 54,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 49,
      'Standard Signup Form': 103,
      'Premium Signup Form': 37,
    },
    signup_forms_previous: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 69,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 49,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 45,
      'Standard Signup Form': 96,
      'Premium Signup Form': 34,
    },
    signup_forms_previous_year: {
      '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 64,
      'ADD ON After qualified PA fee reduced (customer signup/payment form)': 45,
      'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 42,
      'Standard Signup Form': 91,
      'Premium Signup Form': 32,
    },
  },
];

export const mockPaymentsBySignupFormBreakdown: TReportPaymentsBySignupFormBreakdownData[] =
  [
    {
      date: '11/01/25',
      signup_forms: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 4500,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 3200,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 2800,
        'Standard Signup Form': 6700,
        'Premium Signup Form': 2300,
      },
      signup_forms_previous: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 4000,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 2800,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 2500,
        'Standard Signup Form': 6000,
        'Premium Signup Form': 2000,
      },
      signup_forms_previous_year: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 3500,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 2400,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 2200,
        'Standard Signup Form': 5500,
        'Premium Signup Form': 1800,
      },
    },
    {
      date: '11/02/25',
      signup_forms: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 5200,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 3800,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 3300,
        'Standard Signup Form': 7400,
        'Premium Signup Form': 2600,
      },
      signup_forms_previous: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 4700,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 3300,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 2900,
        'Standard Signup Form': 6700,
        'Premium Signup Form': 2300,
      },
      signup_forms_previous_year: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 4200,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 2900,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 2600,
        'Standard Signup Form': 6200,
        'Premium Signup Form': 2100,
      },
    },
    {
      date: '11/03/25',
      signup_forms: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 5800,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 4200,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 3600,
        'Standard Signup Form': 8100,
        'Premium Signup Form': 2900,
      },
      signup_forms_previous: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 5300,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 3700,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 3200,
        'Standard Signup Form': 7400,
        'Premium Signup Form': 2600,
      },
      signup_forms_previous_year: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 4800,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 3300,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 2900,
        'Standard Signup Form': 6800,
        'Premium Signup Form': 2400,
      },
    },
    {
      date: '11/04/25',
      signup_forms: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 6100,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 4500,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 3900,
        'Standard Signup Form': 8800,
        'Premium Signup Form': 3200,
      },
      signup_forms_previous: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 5600,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 4000,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 3500,
        'Standard Signup Form': 8100,
        'Premium Signup Form': 2900,
      },
      signup_forms_previous_year: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 5100,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 3600,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 3200,
        'Standard Signup Form': 7500,
        'Premium Signup Form': 2700,
      },
    },
    {
      date: '11/05/25',
      signup_forms: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 6400,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 4800,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 4200,
        'Standard Signup Form': 9500,
        'Premium Signup Form': 3500,
      },
      signup_forms_previous: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 5900,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 4300,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 3800,
        'Standard Signup Form': 8800,
        'Premium Signup Form': 3200,
      },
      signup_forms_previous_year: {
        '(CM) Competition | $100k 3 Contracts | No Trailing Drawdown | No Refunds | Will NOT qualify for PA (customer signup/payment form)': 5400,
        'ADD ON After qualified PA fee reduced (customer signup/payment form)': 3900,
        'ADD ON After qualified PA fee reduced 91 (customer signup/payment form)': 3500,
        'Standard Signup Form': 8200,
        'Premium Signup Form': 3000,
      },
    },
  ];

export const mockPaymentsMinusRefundsByCustomerCountry: TReportPaymentsMinusRefundsByCustomerCountryData[] =
  [];

export const mockPaymentsMinusRefundsByCustomerState: TReportPaymentsMinusRefundsByCustomerStateData[] =
  [
    {
      date: '11/01/25',
      states: {
        [productTypeOptions[0].value]: 150000,
        [productTypeOptions[1].value]: 62000,
        [productTypeOptions[2].value]: 33000,
        [productTypeOptions[3].value]: 20000,
        [productTypeOptions[4].value]: 13000,
      },
      states_previous: {
        [productTypeOptions[0].value]: 145000,
        [productTypeOptions[1].value]: 60000,
        [productTypeOptions[2].value]: 32000,
        [productTypeOptions[3].value]: 19000,
        [productTypeOptions[4].value]: 12500,
      },
      states_previous_year: {
        [productTypeOptions[0].value]: 140000,
        [productTypeOptions[1].value]: 58000,
        [productTypeOptions[2].value]: 31000,
        [productTypeOptions[3].value]: 18000,
        [productTypeOptions[4].value]: 12000,
      },
    },
    {
      date: '11/02/25',
      states: {
        [productTypeOptions[0].value]: 155000,
        [productTypeOptions[1].value]: 64000,
        [productTypeOptions[2].value]: 34000,
        [productTypeOptions[3].value]: 21000,
        [productTypeOptions[4].value]: 13500,
      },
      states_previous: {
        [productTypeOptions[0].value]: 150000,
        [productTypeOptions[1].value]: 62000,
        [productTypeOptions[2].value]: 33000,
        [productTypeOptions[3].value]: 20000,
        [productTypeOptions[4].value]: 13000,
      },
      states_previous_year: {
        [productTypeOptions[0].value]: 145000,
        [productTypeOptions[1].value]: 60000,
        [productTypeOptions[2].value]: 32000,
        [productTypeOptions[3].value]: 19000,
        [productTypeOptions[4].value]: 12500,
      },
    },
    {
      date: '11/03/25',
      states: {
        [productTypeOptions[0].value]: 160000,
        [productTypeOptions[1].value]: 66000,
        [productTypeOptions[2].value]: 35000,
        [productTypeOptions[3].value]: 22000,
        [productTypeOptions[4].value]: 14000,
      },
      states_previous: {
        [productTypeOptions[0].value]: 155000,
        [productTypeOptions[1].value]: 64000,
        [productTypeOptions[2].value]: 34000,
        [productTypeOptions[3].value]: 21000,
        [productTypeOptions[4].value]: 13500,
      },
      states_previous_year: {
        [productTypeOptions[0].value]: 150000,
        [productTypeOptions[1].value]: 62000,
        [productTypeOptions[2].value]: 33000,
        [productTypeOptions[3].value]: 20000,
        [productTypeOptions[4].value]: 13000,
      },
    },
    {
      date: '11/04/25',
      states: {
        [productTypeOptions[0].value]: 165000,
        [productTypeOptions[1].value]: 68000,
        [productTypeOptions[2].value]: 36000,
        [productTypeOptions[3].value]: 23000,
        [productTypeOptions[4].value]: 14500,
      },
      states_previous: {
        [productTypeOptions[0].value]: 160000,
        [productTypeOptions[1].value]: 66000,
        [productTypeOptions[2].value]: 35000,
        [productTypeOptions[3].value]: 22000,
        [productTypeOptions[4].value]: 14000,
      },
      states_previous_year: {
        [productTypeOptions[0].value]: 155000,
        [productTypeOptions[1].value]: 64000,
        [productTypeOptions[2].value]: 34000,
        [productTypeOptions[3].value]: 21000,
        [productTypeOptions[4].value]: 13500,
      },
    },
  ];

export const mockPaymentsVsRefunds: TReportPaymentsVsRefundsData[] = [
  {
    date: '11/01/25',
    income: 150000,
    payment: 140000,
    refund: 5000,
    chargeback: 1000,
    income_previous: 145000,
    payment_previous: 135000,
    refund_previous: 4800,
    chargeback_previous: 900,
    income_previous_year: 140000,
    payment_previous_year: 130000,
    refund_previous_year: 4500,
    chargeback_previous_year: 800,
  },
  {
    date: '11/02/25',
    income: 155000,
    payment: 145000,
    refund: 5200,
    chargeback: 1100,
    income_previous: 150000,
    payment_previous: 140000,
    refund_previous: 5000,
    chargeback_previous: 1000,
    income_previous_year: 145000,
    payment_previous_year: 135000,
    refund_previous_year: 4800,
    chargeback_previous_year: 900,
  },
  {
    date: '11/03/25',
    income: 160000,
    payment: 150000,
    refund: 5400,
    chargeback: 1200,
    income_previous: 155000,
    payment_previous: 145000,
    refund_previous: 5200,
    chargeback_previous: 1100,
    income_previous_year: 150000,
    payment_previous_year: 140000,
    refund_previous_year: 5000,
    chargeback_previous_year: 1000,
  },
  {
    date: '11/04/25',
    income: 165000,
    payment: 155000,
    refund: 5600,
    chargeback: 1300,
    income_previous: 160000,
    payment_previous: 150000,
    refund_previous: 5400,
    chargeback_previous: 1200,
    income_previous_year: 155000,
    payment_previous_year: 145000,
    refund_previous_year: 5200,
    chargeback_previous_year: 1100,
  },
  {
    date: '11/05/25',
    income: 170000,
    payment: 160000,
    refund: 5800,
    chargeback: 1400,
    income_previous: 165000,
    payment_previous: 155000,
    refund_previous: 5600,
    chargeback_previous: 1300,
    income_previous_year: 160000,
    payment_previous_year: 150000,
    refund_previous_year: 5400,
    chargeback_previous_year: 1200,
  },
];

export const mockProductConversion: TReportProductConversionData[] = [
  {
    date: '11/25/25',
    conversion_percentage: 30.0,
    revenue: 16875.0,
    conversion_percentage_previous: 30.0,
    revenue_previous: 15750.0,
    conversion_percentage_previous_year: 30.0,
    revenue_previous_year: 14250.0,
  },
  {
    date: '11/26/25',
    conversion_percentage: 32.5,
    revenue: 19500.0,
    conversion_percentage_previous: 32.0,
    revenue_previous: 18000.0,
    conversion_percentage_previous_year: 32.0,
    revenue_previous_year: 16000.0,
  },
  {
    date: '11/27/25',
    conversion_percentage: 33.8,
    revenue: 22000.0,
    conversion_percentage_previous: 32.9,
    revenue_previous: 19750.0,
    conversion_percentage_previous_year: 33.0,
    revenue_previous_year: 17750.0,
  },
  {
    date: '11/28/25',
    conversion_percentage: 31.1,
    revenue: 14775.0,
    conversion_percentage_previous: 30.0,
    revenue_previous: 13500.0,
    conversion_percentage_previous_year: 30.0,
    revenue_previous_year: 12000.0,
  },
  {
    date: '11/29/25',
    conversion_percentage: 32.9,
    revenue: 21000.0,
    conversion_percentage_previous: 32.0,
    revenue_previous: 19625.0,
    conversion_percentage_previous_year: 31.8,
    revenue_previous_year: 17500.0,
  },
  {
    date: '11/30/25',
    conversion_percentage: 34.0,
    revenue: 23375.0,
    conversion_percentage_previous: 32.9,
    revenue_previous: 21375.0,
    conversion_percentage_previous_year: 33.0,
    revenue_previous_year: 19375.0,
  },
  {
    date: '12/01/25',
    conversion_percentage: 33.1,
    revenue: 20250.0,
    conversion_percentage_previous: 32.0,
    revenue_previous: 18375.0,
    conversion_percentage_previous_year: 32.0,
    revenue_previous_year: 16375.0,
  },
];

export const mockRefundsByUsedCoupon: TReportRefundsByUsedCouponData[] = [
  {
    date: '11/01/25',
    refund_amount: 14000,
    refund_amount_previous: 13200,
    refund_amount_previous_year: 12000,
  },
  {
    date: '11/02/25',
    refund_amount: 14800,
    refund_amount_previous: 13900,
    refund_amount_previous_year: 13000,
  },
  {
    date: '11/03/25',
    refund_amount: 16100,
    refund_amount_previous: 15300,
    refund_amount_previous_year: 14300,
  },
  {
    date: '11/04/25',
    refund_amount: 17200,
    refund_amount_previous: 16400,
    refund_amount_previous_year: 15400,
  },
  {
    date: '11/05/25',
    refund_amount: 18400,
    refund_amount_previous: 17600,
    refund_amount_previous_year: 16600,
  },
  {
    date: '11/06/25',
    refund_amount: 19600,
    refund_amount_previous: 18800,
    refund_amount_previous_year: 17800,
  },
  {
    date: '11/07/25',
    refund_amount: 20600,
    refund_amount_previous: 19800,
    refund_amount_previous_year: 18800,
  },
];

export const mockRollingConversion: TReportRollingConversionData[] = [
  {
    date: '11/01/25',
    conversion_percentage: 20,
    conversion_percentage_previous: 55,
    conversion_percentage_previous_year: 32,
  },
  {
    date: '11/02/25',
    conversion_percentage: 12,
    conversion_percentage_previous: 32,
    conversion_percentage_previous_year: 44,
  },
  {
    date: '11/03/25',
    conversion_percentage: 55,
    conversion_percentage_previous: 23,
    conversion_percentage_previous_year: 21,
  },
  {
    date: '11/04/25',
    conversion_percentage: 58,
    conversion_percentage_previous: 34,
    conversion_percentage_previous_year: 52,
  },
  {
    date: '11/05/25',
    conversion_percentage: 88,
    conversion_percentage_previous: 34,
    conversion_percentage_previous_year: 64,
  },
  {
    date: '11/06/25',
    conversion_percentage: 12,
    conversion_percentage_previous: 45,
    conversion_percentage_previous_year: 34,
  },
  {
    date: '11/07/25',
    conversion_percentage: 67,
    conversion_percentage_previous: 44,
    conversion_percentage_previous_year: 77,
  },
];

export const mockTax: TReportTaxData[] = [
  {
    date: '11/01/25',
    tax_amount: 1200,
    tax_amount_previous: 1100,
    tax_amount_previous_year: 1000,
  },
  {
    date: '11/02/25',
    tax_amount: 1350,
    tax_amount_previous: 1250,
    tax_amount_previous_year: 1150,
  },
  {
    date: '11/03/25',
    tax_amount: 1500,
    tax_amount_previous: 1400,
    tax_amount_previous_year: 1300,
  },
  {
    date: '11/04/25',
    tax_amount: 1650,
    tax_amount_previous: 1550,
    tax_amount_previous_year: 1450,
  },
  {
    date: '11/05/25',
    tax_amount: 1800,
    tax_amount_previous: 1700,
    tax_amount_previous_year: 1600,
  },
  {
    date: '11/06/25',
    tax_amount: 1950,
    tax_amount_previous: 1850,
    tax_amount_previous_year: 1750,
  },
  {
    date: '11/07/25',
    tax_amount: 2100,
    tax_amount_previous: 2000,
    tax_amount_previous_year: 1900,
  },
];

export const mockRefundsRate: TReportRefundsRateData[] = [
  {
    date: '11/01/25',
    refunds_rate: 2.5,
    refunds_rate_previous: 2.3,
    refunds_rate_previous_year: 2.0,
  },
  {
    date: '11/02/25',
    refunds_rate: 3.1,
    refunds_rate_previous: 2.9,
    refunds_rate_previous_year: 2.5,
  },
  {
    date: '11/03/25',
    refunds_rate: 2.8,
    refunds_rate_previous: 2.6,
    refunds_rate_previous_year: 2.2,
  },
  {
    date: '11/04/25',
    refunds_rate: 4.2,
    refunds_rate_previous: 3.9,
    refunds_rate_previous_year: 3.5,
  },
  {
    date: '11/05/25',
    refunds_rate: 3.5,
    refunds_rate_previous: 3.2,
    refunds_rate_previous_year: 2.8,
  },
  {
    date: '11/06/25',
    refunds_rate: 2.9,
    refunds_rate_previous: 2.7,
    refunds_rate_previous_year: 2.4,
  },
  {
    date: '11/07/25',
    refunds_rate: 3.7,
    refunds_rate_previous: 3.5,
    refunds_rate_previous_year: 3.0,
  },
];

export const mockUserLifetime: TReportUserLifetimeData[] = [
  { lifetime_range: '1-365 days', number_of_users: 1852 },
  { lifetime_range: '366-730 days', number_of_users: 2019 },
  { lifetime_range: '731-1095 days', number_of_users: 1955 },
  { lifetime_range: '1096-1460 days', number_of_users: 1292 },
  { lifetime_range: '1461-1825 days', number_of_users: 1058 },
  { lifetime_range: '1826-2190 days', number_of_users: 467 },
  { lifetime_range: '2191-2555 days', number_of_users: 47 },
  { lifetime_range: '2556-2920 days', number_of_users: 4 },
];

export const mockUsersByUserGroups: TReportUsersByUserGroupsData[] = [
  { user_group: '20% commision', user_count: 2456 },
  { user_group: '15% summer June and July 2025', user_count: 1834 },
  { user_group: 'Darrell 15%', user_count: 1278 },
];
